import React, { useEffect, useMemo, useRef, useState } from "react";
import { createPortal } from "react-dom";
import "react-datepicker/dist/react-datepicker.css";
import { Field } from "formik";
import {
  FormGroup,
  Label,
  Row,
  Col,
  Input,
  Modal,
  ModalBody,
  ListGroup,
  ListGroupItem,
} from "reactstrap";
import mime from "mime-types";
import { api } from "../../api/api";

import "react-phone-number-input/style.css";
import Title from "../title";
import Select from "react-select";
import AsyncSelect from "react-select/async";
import {
  getAllMembers,
  getMember,
  getIsLinkedPackages,
  importSales,
  downloadSalesTemplate,
  checkIfMemberPaidJoinFees,
  getFollowupPrograms,
  getFirstInstructorFromRotationList,
  getPotentialPackagesByService,
} from "../../redux/actions/api/apiAction";
import { ComonIcons } from "../../contents/commonIcons";
import { useDispatch, useSelector } from "react-redux";
import DatePicker from "react-datepicker";
import { toastr } from "react-redux-toastr";
import moment from "moment";
import { setLoading } from "../../redux/actions/common/common-actions";
import ReactSelect from "react-select";
import { setMembershipCardsScannerPopupOpen } from "../../redux/actions/membershipCard/membershipCardAction";
import { lookupItems, voicePackageRow } from "../voiceAdd/openForm";
import { saleDraftNeedsIdentity } from "../voiceAdd/draftProblems";
import { saveVoiceDraftEdit } from "../voiceAdd/saveDraftEdit";
import {
  persistStashedSaleIdentity,
  stashVoiceSaleIdentity,
} from "../voiceAdd/voiceSaleIdentity";
import { calculateMemberCreditSale } from "./memberCreditUtils";
import CustomDropdown from "../customDropdown";
import { store } from "../../redux/storeConfig/store";
import { ImportDataPopup } from "../importData/ImportDataPopup";
import { MemberInfoModal } from "../modals/memberInfo";
import { DiscountSaleCalculator } from "../modals/discountSaleCalculator";
import ProductComponentV2 from "./selectProducFormV2";
import UploadOrCapture from "./uploadOrCapture";
import { getStaffsList } from "../../views/pages/gymPortion/reports/utils";

// Attach the node before the calendar mounts. The built-in portal mounts too late,
// so the calendar stays invisible (opacity 0) and never gets a position.
function SaleDatePopperContainer({ children }) {
  const nodeRef = useRef(null);
  if (!nodeRef.current) {
    const node = document.createElement("div");
    node.className = "sale-datepicker-portal";
    document.body.appendChild(node);
    nodeRef.current = node;
  }
  useEffect(() => {
    const node = nodeRef.current;
    return () => {
      if (node && node.parentNode) node.parentNode.removeChild(node);
    };
  }, []);
  return createPortal(children, nodeRef.current);
}

const customStyle = {
  control: (provided, state) => ({
    ...provided,
    background: "#F5F7F8",
    padding: 0,
    height: "auto",
    width: "100%",
    border: "none",
    boxShadow: "none",
    "&:hover": {
      border: "none",
      boxShadow: "none",
    },
  }),
};

export const importDropdownListItems = [
  {
    innertitle: "Download Template",
    // svg: require("../../assets/images/download.svg"),
  },
  {
    innertitle: "Upload Sales",
    // svg: require("../../assets/images/upload-sm.svg"),
    svg: require("../../assets/images/excel.svg"),
  },
];
const timeRulesOf = (pack) => {
  if (!pack) return [];
  if (Array.isArray(pack.peakOffPeakPrices)) return pack.peakOffPeakPrices;
  if (Array.isArray(pack.prices)) {
    return pack.prices.filter((rule) => rule.pricingStrategy === "TIME_RANGE");
  }
  return [];
};

export const FormFirstStep = (formikProps) => {
  const {
    values,
    errors,
    touched,
    setFieldValue,
    members,
    setSelectedFile,
    memberCreditEnabled,
    creditRefreshKey,
  } = formikProps;
  const [membersList, setMemberList] = useState([]);
  const [selectedPackages, setSelectedPackages] = useState([]);
  const [bookingPackages, setBookingPackages] = useState([]);
  const [bookingPackagesLoading, setBookingPackagesLoading] = useState(false);
  const [packageMenuBox, setPackageMenuBox] = useState(null);
  const bookingPackagesRequestRef = useRef(0);
  const previousPaymentTypeRef = useRef(values.paymentType);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [selectedMainMember, setSelectedMainMember] = React.useState();
  const [singlePackage, setSinglePackage] = useState();
  const [singleProduct, setSingleProduct] = useState();
  const [toDelete, setToDelete] = useState(false);
  const [toDeleteProduct, setToDeleteProduct] = useState(false);
  const [showComReason, setShowComReason] = useState(false);

  const [showExtendDuration, setShowExtendDuration] = useState({});
  const [userRole, setUserRole] = useState("GYM");
  const [totalPrice, setTotalPrice] = useState(0);
  const [totalRecieved, setTotalRecieved] = useState(0);

  const [totalDiscount, setTotalDiscount] = useState(0);
  const fileInputRef = useRef(null);
  const [selectedSaleServices, setSelectedSaleServices] = useState([]);
  const [memberHasIdDocument, setMemberHasIdDocument] = useState(null);
  const [priceWithTax, setPriceWithTax] = useState(0);
  const [content, setContent] = useState(null);
  const [singlePackageTouched, setSinglePackageTouched] = useState(false);
  const [singleProductTouched, setSingleProductTouched] = useState(false);
  const [isImportDataLoading, setIsImportDataLoading] = useState(false);
  const [memberCreditBalance, setMemberCreditBalance] = useState(0);
  const [memberCreditLoading, setMemberCreditLoading] = useState(false);
  const [memberCreditError, setMemberCreditError] = useState("");
  const [totalAmountAfterInsuranceCoverage,setTotalAmountAfterInsuranceCoverage]=useState(null);

  const { packages: packageData } = useSelector((state) => state.packages);
  const { member, allMembers, memberPaidJoiningFees } = useSelector(
    (state) => state.member
  );
  const { addToBookingListModal, bookAppointmentModal } = useSelector(
    (state) => state.class
  );
  const { trainers } = useSelector((state) => state.trainer);
  const { productsLimit, productsPage } = useSelector((state) => state.product);
  const { gym, gymConfig } = useSelector((state) => state.gym);
  const { settings } = useSelector((state) => state.gym.gym);
  const memberCreditPackageDue = Number(
    totalAmountAfterInsuranceCoverage != null
      ? totalAmountAfterInsuranceCoverage
      : priceWithTax || values.totalPrice || 0
  );
  const memberCreditApplicable = Boolean(
    memberCreditEnabled &&
      selectedPackages.length === 1 &&
      selectedProducts.length === 0 &&
      memberCreditPackageDue > 0
  );
  const partialPaymentApplicable = Boolean(
    selectedPackages.length === 1 && selectedProducts.length === 0
  );
  const memberPhysicalPayment =
    values.paymentType === "SP"
      ? values.split.reduce(
          (sum, payment) => sum + (Number(payment?.amount) || 0),
          0
        )
      : Number(values.physicalPayment) || 0;
  const memberCreditCalculation = calculateMemberCreditSale({
    packageDue: memberCreditPackageDue,
    availableCredit: memberCreditBalance,
    creditToUse: values.creditToUse,
    physicalPayment: memberPhysicalPayment,
  });

  useEffect(() => {
    const memberId = values?.user?.value;
    if (!memberCreditEnabled || !memberId) {
      setMemberCreditBalance(0);
      setMemberCreditError("");
      setFieldValue("creditToUse", 0);
      return;
    }

    let active = true;
    setMemberCreditLoading(true);
    setMemberCreditError("");
    api(`member/${memberId}/credit`, {}, "get")
      .then((res) => {
        if (!active) return;
        if (res?.status === 200) {
          setMemberCreditBalance(Number(res?.data?.data?.balance) || 0);
        } else {
          setMemberCreditBalance(0);
          setMemberCreditError("Unable to load member credit.");
        }
      })
      .catch(() => {
        if (!active) return;
        setMemberCreditBalance(0);
        setMemberCreditError("Unable to load member credit.");
      })
      .finally(() => active && setMemberCreditLoading(false));

    return () => {
      active = false;
    };
  }, [memberCreditEnabled, values?.user?.value, creditRefreshKey]);

  useEffect(() => {
    if (!memberCreditEnabled) return;

    setFieldValue("creditToUse", 0);
    setFieldValue("physicalPayment", 0);
    setFieldValue("memberCredit", undefined);
    setFieldValue("split", []);
    setFieldValue("receivedAmount", "0.00");
    setFieldValue("remainingAmount", "0.00");
    setTotalRecieved(0);
    setMemberCreditError("");
  }, [
    memberCreditEnabled,
    selectedPackages,
    singlePackageTouched,
    selectedProducts,
    singleProductTouched,
    setFieldValue,
  ]);

  useEffect(() => {
    if (!memberCreditApplicable) {
      if (values.memberCredit) setFieldValue("memberCredit", undefined);
      return;
    }

    const calculation = memberCreditCalculation;
    setFieldValue("receivedAmount", calculation.receivedForSubscription.toFixed(2));
    setFieldValue("remainingAmount", calculation.remainingAmount.toFixed(2));
    setFieldValue(
      "paymentStatus",
      calculation.remainingAmount === 0 ? "F" : "P"
    );
    setFieldValue("memberCredit", {
      creditToUse: calculation.creditUsed,
      newPhysicalPayment: calculation.physicalPayment,
      advancePayment: { amount: calculation.advanceCredit },
    });
  }, [
    memberCreditApplicable,
    memberCreditCalculation.creditUsed,
    memberCreditCalculation.physicalPayment,
    memberCreditCalculation.advanceCredit,
    memberCreditCalculation.receivedForSubscription,
    memberCreditCalculation.remainingAmount,
  ]);

  useEffect(() => {
    if (!partialPaymentApplicable && values.paymentStatus === "P") {
      setFieldValue("paymentStatus", "F");
      setFieldValue("remainingAmount", "0.00");
    }
  }, [partialPaymentApplicable, values.paymentStatus]);
  const { loginUser } = useSelector((state) => state.login);
  const [users,setUserList]=useState([])
  const { permissions, subAdminType, subAdminPermissions } = useSelector(
    (state) => state.permissions
  );
  const { features, gymFeaturesObject } = useSelector(
    (state) => state.features
  );
  const {
    memberGymByMembershipCardId,
    membershipCardsScannerAction,
  } = useSelector((state) => state.membershipCard);

  const { staffs } = useSelector((state) => state.staff);

  const getAllUsersList=async()=>{
    const users=await getStaffsList(true,["STAFF","SUB_ADMIN"])
    setUserList(users)
  }
  
  
  const { followupPrograms } = useSelector((state) => state.followupProgram);

  const [membersRelations, setMembersRelations] = useState(
    member?.relations || []
  );
  const [paymentOptions, setPaymentOptions] = useState([
    {
      label: "Visa",
      value: "CC",
    },
    {
      label: "Bank",
      value: "BA",
    },
    { label: "Cash", value: "L" },
  ]);
  let options = [
    {
      value: 1,
      label: "Subscription",
      show:
        gymConfig?.manageMemberships?.enabled &&
        (loginUser.role == "STAFF"
          ? permissions["S-SAL-ADD"]
          : subAdminType === "SUB_ADMIN"
          ? subAdminPermissions["S-SAL-ADD"]
          : true),
    },
    {
      value: 2,
      label: "Product",
      show:
        gymConfig?.retail?.enabled &&
        (loginUser.role == "STAFF"
          ? permissions["S-SAL-PRO"]
          : subAdminType === "SUB_ADMIN"
          ? subAdminPermissions["S-SAL-PRO"]
          : true),
    },
    {
      value: 3,
      label: "Services",
      show:
        gymConfig?.manageMemberships?.enabled &&
        (loginUser.role == "STAFF"
          ? permissions["S-SAL-ADD"]
          : subAdminType === "SUB_ADMIN"
          ? subAdminPermissions["S-SAL-ADD"]
          : true),
    },
  ];

  const [selectedCategories, setSelectedCategories] = useState([]);
  const [paymentOption2, setPaymentOption2] = useState([
    {
      label: "Visa",
      value: "CC",
    },
    { label: "Cash", value: "L" },
    {
      label: "Bank",
      value: "BA",
    },
  ]);
  const [isMemberLoading, setIsMemberLoading] = useState(false);
  const [isMemberInfoModalOpen, setIsMemberInfoModalOpen] = useState(false);
  const [showOptions, setShowOptions] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [inputValue, setInputValue] = useState("");
  const [showProductDialog, setShowProductDialog] = useState(false);
  const [discountSaleCalculatorOpen, setDiscountSaleCalculatorOpen] = useState(
    false
  );
  const [
    selectedPackageForDiscountCalculator,
    setSelectedPackageForDiscountCalculator,
  ] = useState(null);
  const [
    selectedProductForDiscountCalculator,
    setSelectedProductForDiscountCalculator,
  ] = useState(null);
  const [firstInstructorInRotationList, setFirstInstructorInRotationList] = useState(null);
  const [followupProgramEnabled, setFollowupProgramEnabled] = useState(false);
  const [insuranceDetails,setInsuranceDetails]=useState(null);
  const [hasInsuranceEligiblePackage,setHasInsuranceEligiblePackage]=useState(false)
  const handleInputChange = (e) => {
    const value = e.target.value;
    setInputValue(value);
    // You may want to filter options based on the input value here
  };

  const handleInputClick = () => {
    setShowOptions(!showOptions);
  };
  // Memoize filtered package data for both service types
  const gymPackages = useMemo(
    () => packageData.filter((p) => p.planType === "GYM"),
    [packageData]
  );

  const availablePackageData = values.fromBooking
    ? bookingPackages
    : packageData.filter((pack) => timeRulesOf(pack).length <= 1);
  useEffect(() => {
    if (!packageMenuBox) return undefined;
    const close = (event) => {
      const menu = document.querySelector(".sale-package-picker__menu");
      const control = document.getElementById("package-selector");
      if (menu && menu.contains(event.target)) return;
      if (control && control.contains(event.target)) return;
      setPackageMenuBox(null);
    };
    const closeMenu = () => setPackageMenuBox(null);
    document.addEventListener("mousedown", close);
    window.addEventListener("resize", closeMenu);
    return () => {
      document.removeEventListener("mousedown", close);
      window.removeEventListener("resize", closeMenu);
    };
  }, [packageMenuBox]);

  const servicePackages = useMemo(
    () =>
      availablePackageData.filter(
        (p) =>
          p.planType === "pt" ||
          p.planType === "class" ||
          p.planType === "court"
      ),
    [availablePackageData]
  );
  const handleOptionClick = (option) => {
    setSelectedOption(option);
    if (option.value == 2) {
      setShowProductDialog(true);
    } else {
      setShowProductDialog(false);
    }
    setInputValue(option.label);
    setShowOptions(false);
    setSelectedSaleServices([option]);
    setFieldValue("selectedSaleServices", [option]);
  };
  const dispatch = useDispatch();
  React.useEffect(() => {
    setFieldValue(
      "user",
      { label: member?.name || "", value: member?.id || undefined } || ""
    );
    if (member?.id) {
      if (gymFeaturesObject["joiningFees"]) {
        dispatch(checkIfMemberPaidJoinFees(member.id));
        /** when user not paid joiningFees and there is payment types  :
         * full or partial (the user should paid minimum more than joining fees )
         * 500 / 100
         * 50 the received amount should be more than joining fees amount
         * recieved amount < joining 100
         * 200 (100 joining fees )
         * 100 remaing (400)
         * the remaining amount should
         */
      }
    }
    getAllUsersList()
  }, []);

  useEffect(() => {
    dispatch(
      getAllMembers(
        JSON.parse(localStorage.getItem("connectToFitGymPanelUser")).gym
      )
    );
  }, []);

  const fetchFirstInstructorInRotationList = async () => {
      const instructor = await store.dispatch(getFirstInstructorFromRotationList());
      setFirstInstructorInRotationList(instructor ? instructor : trainers?.length && trainers[0].id);      
  };

  useEffect(() => {
    if (gymConfig?.followupProgram?.enabled) {
      dispatch(getFollowupPrograms({}));
      fetchFirstInstructorInRotationList();
    }
  }, [gymConfig]);

  useEffect(() => {
    setFollowupProgramEnabled(gymConfig?.followupProgram?.enabled && settings?.followupProgram?.enabled)
  }, [gymConfig, settings]);

  useEffect(() => {
    let memberList = allMembers?.map((item, idx) => {
      return {
        label: `${item.name}-${item.phone?item.phone:"No Phone"}`,
        value: {
          id: item.id,
          image: item.image,
          
        },
        phone:item?.phone,
      };
    });
    setMemberList(memberList);
    let loginObj = JSON.parse(localStorage.getItem("connectToFitGymPanelUser"));
    let { role, trainer, name } = loginObj;
    setUserRole(role);
    if (role === "TRAINER") {
      setFieldValue("memberShipType", "PT");
    }
  }, [allMembers]);

  const getMemberDocumnet = async (id) => {
    if (!id || String(id).indexOf("member-") === 0 || selectedMainMember?.pending) {
      setMemberHasIdDocument(false);
      return;
    }
    setMemberHasIdDocument(null);
    try {
      let res = await api(`member/${id}/info/documents?search=ID`, {}, "get");
      setMemberHasIdDocument(Boolean(res?.data?.data?.length));
    } catch (error) {
      setMemberHasIdDocument(false);
    }
  };
  useEffect(() => {
    const memberId =
      (selectedMainMember && selectedMainMember.value && selectedMainMember.value.id) ||
      (selectedMainMember && selectedMainMember.id);
    if (memberId || (selectedMainMember && selectedMainMember.pending)) {
      getMemberDocumnet(memberId);
    }
  }, [selectedMainMember]);

  useEffect(() => {
    let isCurrentRequest = true;
    if (selectedMainMember?.id) {
      if (values.fromBooking) {
        const {
          planType,
          serviceId,
          numberOfPlayers,
          trainerId,
        } = values.bookingData;
        const requestId = ++bookingPackagesRequestRef.current;
        setBookingPackages([]);
        setBookingPackagesLoading(true);
        setSelectedPackages([]);
        setSinglePackage();
        setFieldValue("selectedSaleServices", [{
            value: 1,
            label: "Subscription",
        }]);
        dispatch(
          getPotentialPackagesByService({
            planType,
            serviceId,
            numberOfPlayers,
            trainerId,
            forMatch: values.bookingData?.forMatch,
            bookingCourtId: values.bookingData?.bookingCourtId,
            matchCapacity: values.bookingData?.matchCapacity,
          })
        ).then((packages) => {
          if (
            isCurrentRequest &&
            requestId === bookingPackagesRequestRef.current
          ) {
            setBookingPackages(packages || []);
            setBookingPackagesLoading(false);
          }
        });
      } else {
        bookingPackagesRequestRef.current += 1;
        setBookingPackages([]);
        setBookingPackagesLoading(false);
        dispatch(
          getIsLinkedPackages(
            1,
            999999,
            true,
            true,
            null,
            null,
            null,
            selectedMainMember.gender
          )
        );
      }
    }
    return () => {
      isCurrentRequest = false;
    };
  }, [
    selectedMainMember?.id,
    selectedMainMember?.gender,
    values.fromBooking,
    values.bookingData?.planType,
    values.bookingData?.serviceId,
    values.bookingData?.numberOfPlayers,
    values.bookingData?.trainerId,
    values.bookingData?.forMatch,
    values.bookingData?.bookingCourtId,
    values.bookingData?.matchCapacity,
  ]);

  useEffect(() => {
    if (selectedMainMember && singlePackage) {
      const {
        trainer,
        trainer_name,
        createdAt,
        updatedAt,
        ...rest
      } = singlePackage;
      rest["assignableMembers"] = [selectedMainMember, ...member?.relations];
      // rest['member'] has or operator because there are two cases: the first case is creating a sale from the "Add Sale" tab => gym admin selects the main member, the second case is for adding a sale from the "Add Member" in class info pop-up ===> the user is predefined and read from member state which is dispatched in class info popup
      rest["member"] =
        parseInt(selectedMainMember.value?.id) || selectedMainMember.id;
      rest["startDate"] = new Date();
      if (followupProgramEnabled && singlePackage.planType == "GYM") {
        rest["followupProgram"] = followupPrograms?.length && followupPrograms[0]?.id;
        rest["assignedTrainer"] =!singlePackage.assignedTrainer? firstInstructorInRotationList?.id:singlePackage.assignedTrainer;
        rest["isRotationChanged"]=rest["assignedTrainer"]!==firstInstructorInRotationList?.id ?true:false

      }
      rest.poolAccessType=singlePackage.poolAccessType
      if (!values.fromBooking) {
        const timeRules = timeRulesOf(singlePackage);
        if (timeRules.length === 1 && timeRules[0].id != null) {
          rest.pricingRuleId = timeRules[0].id;
          const rulePrice = Number(timeRules[0].price);
          if (Number.isFinite(rulePrice)) rest.price = rulePrice;
        }
      }
      setSelectedPackages([...selectedPackages, rest]);
      setSinglePackage();
    }
  }, [singlePackage]);

  useEffect(() => {
    if (selectedMainMember && singleProduct) {
      const { ...rest } = singleProduct;
      rest["assignableMembers"] = [selectedMainMember, ...member?.relations];
      // rest['member'] has or operator because there are two cases: the first case is creating a sale from the "Add Sale" tab => gym admin selects the main member, the second case is for adding a sale from the "Add Member" in class info pop-up ===> the user is predefined and read from member state which is dispatched in class info popup
      rest["member"] =
        parseInt(selectedMainMember.value) || selectedMainMember.id;
      // rest['quantity'] = 1
      if (!selectedProducts.find((el) => el.id == singleProduct.id)) {
        setSelectedProducts([...selectedProducts, rest]);
      }
      setSingleProduct(null);
    }
  }, [singleProduct]);

  useEffect(() => {
    if (typeof toDelete == "number") {
      setSelectedPackages(
        selectedPackages.filter((pckg, idx) => {
          return idx !== toDelete;
        })
      );
    }
    setToDelete(null);
  }, [toDelete]);
  useEffect(() => {
    if (typeof toDeleteProduct == "number") {
      setSelectedProducts(
        selectedProducts.filter((pckg) => {
          return pckg.id !== toDeleteProduct;
        })
      );
    }
    setSingleProduct(null);
    setToDeleteProduct(null);
  }, [toDeleteProduct]);

  useEffect(() => {
    let sum, discount, totalWithTax, totalWithTaxRounded, totalAmountAfterInsuranceCoverage;
    let insuranceEligibleWithTax = 0; 
    let nonInsuranceWithTax = 0;     

    switch (selectedPackages.length) {
      case 0: {
        sum = 0;
        discount = 0;
        totalWithTax = 0.0;
        setFieldValue("split", []);
        break;
      }
      case 1: {
        sum =
          selectedPackages[0].price / (1 + (formikProps.values.tax || 0) / 100);
          discount = sum * (selectedPackages[0].discount / 100) || 0;
          totalWithTax =
            (sum - discount) * (1 + (formikProps.values.tax || 0) / 100);
          totalWithTaxRounded = (Math.round(totalWithTax * 100) / 100).toFixed(2);
        const hasSupportedInsurence = selectedPackages[0].supportInsurance;
        if (hasSupportedInsurence && insuranceDetails && insuranceDetails?.Copayment) {
          const copaymentPercent = insuranceDetails?.Copayment || 0;
          totalAmountAfterInsuranceCoverage =
            Math.round(totalWithTaxRounded * (copaymentPercent / 100) * 100) / 100;
        }
        break;
      }
      default: {
        let discountArr = selectedPackages.map(
          (pack) =>
            (pack.price / (1 + (formikProps.values.tax || 0) / 100)) *
            (pack.discount / 100 || 0)
        );
        let pricesArr = selectedPackages.map((pack) => pack.price);
        let sum1 = pricesArr.reduce((a, b) => a + b);
        sum = sum1 / (1 + (formikProps.values.tax || 0) / 100);
        discount = discountArr.reduce((a, b) => a + b);
        selectedPackages.forEach((pack) => {
          const base =
            pack.price / (1 + (formikProps.values.tax || 0) / 100);
          const packDiscount = base * (pack.discount / 100 || 0);
          const net = base - packDiscount;
          const withTax = net * (1 + (formikProps.values.tax || 0) / 100);

          if (pack.supportInsurance) {
            insuranceEligibleWithTax += withTax;
          } else {
            nonInsuranceWithTax += withTax;
          }
        });

        totalWithTax = (
          (sum - discount) *
          (1 + (formikProps.values.tax || 0) / 100)
        ).toFixed(2);
        totalWithTaxRounded = (Math.round(totalWithTax * 100) / 100).toFixed(2);
        if (insuranceDetails && insuranceDetails?.Copayment) {
          const copaymentPercent = insuranceDetails?.Copayment || 0;
          totalAmountAfterInsuranceCoverage =
           ((Math.round(insuranceEligibleWithTax * (copaymentPercent / 100) * 100) / 100)+nonInsuranceWithTax);

          
        }
        break;
      }
    }
    switch (selectedProducts.length) {
      case 1: {
        let productSum = 0;
        productSum =
          (selectedProducts[0].price *
            (selectedProducts[0].quantity ? selectedProducts[0].quantity : 0)) /
          (1 + (formikProps.values.tax || 0) / 100);
        sum = sum + productSum;
        discount =
          discount +
          (productSum *
            (selectedProducts[0]?.discount
              ? selectedProducts[0].discount
              : 0)) /
            100;

        totalWithTax =
          (sum - discount) * (1 + (formikProps.values.tax || 0) / 100);
        totalWithTaxRounded = (Math.round(totalWithTax * 100) / 100).toFixed(2);
        break;
      }
      default: {
        if (selectedProducts.length > 0) {
          let discountArr = selectedProducts.map(
            (pack) =>
              ((pack.price * (pack.quantity || 1)) /
                  (1 + (formikProps.values.tax || 0) / 100)) *
                (pack?.discount / 100 || 0)
          );
          let pricesArr = selectedProducts.map((pack) => {
            return {
              price: pack.price,
              quantity: pack.quantity ? pack.quantity : 0,
            };
          });
          let sum1 = pricesArr.reduce(
            (a, b) => a + b.price * b.quantity,
            0
          );
          sum = sum + sum1 / (1 + (formikProps.values.tax || 0) / 100);
          discount = discount + discountArr.reduce((a, b) => a + b);
          totalWithTax = (
            (sum - discount) *
            (1 + (formikProps.values.tax || 0) / 100)
          ).toFixed(2);
          totalWithTaxRounded = (Math.round(totalWithTax * 100) / 100).toFixed(2);
          break;
        }
      }
    }
    const hasInsuranceEligiblePackage = selectedPackages.some(
      (p) => p.supportInsurance
    );
    setHasInsuranceEligiblePackage(hasInsuranceEligiblePackage);
    setTotalPrice(sum);
    setTotalDiscount(discount.toFixed(2));
    setPriceWithTax(totalWithTaxRounded);
    setFieldValue("netPrice", sum);
    setFieldValue("discount", discount);
    setFieldValue("totalPrice", parseFloat(totalWithTaxRounded).toFixed(2));

    if (totalAmountAfterInsuranceCoverage !== undefined) {
      setFieldValue("totalAmountAfterInsuranceCoverage", totalAmountAfterInsuranceCoverage);
      setTotalAmountAfterInsuranceCoverage(totalAmountAfterInsuranceCoverage);
    } else {
      setFieldValue("totalAmountAfterInsuranceCoverage", undefined);
      setTotalAmountAfterInsuranceCoverage(null);
    }

    setFieldValue("packages", selectedPackages);
    setFieldValue("products", selectedProducts);
    setFieldValue(
      "requiredAttachment",
      selectedPackages.some((pack) => Boolean(pack.requiredAttachment))
    );

    if (discount > 0) {
      setFieldValue("hasDisount", true);
    } else {
      setFieldValue("hasDisount", false);
    }
  }, [
    selectedPackages,
    singlePackageTouched,
    selectedProducts,
    singleProductTouched,
    formikProps.values.paymentType,
  ]);


  useEffect(() => {
    if (member?.id) {
      setSelectedMainMember(member);
      setMembersRelations(member.relations);
      if (gymFeaturesObject["joiningFees"]) {
        dispatch(checkIfMemberPaidJoinFees(member.id));
      }
      setFieldValue(
        "user",
        { label: member?.name || "", value: member?.id || undefined } || ""
      );
      /**
       * here will check if member has metadata and insuranceDetails
       * if he has a metadata and insuranceDetails will show insuransce company converage amount, company name, policy number,   amount after coverage 
       * then update the totalPriceAfterCovarage validations accordingly
       *  */ 
      if(member?.metaData && member?.metaData?.insuranceDetails&& member?.metaData?.insuranceDetails?.hasInsurance=="yes"){
        const {Copayment,insuranceCardNumber,insuranceCompany}=member?.metaData?.insuranceDetails;
        setFieldValue("insuranceDetails",{Copayment,insuranceCardNumber,insuranceCompany});
        setInsuranceDetails({Copayment,insuranceCardNumber,insuranceCompany});
      }
    }
  }, [member]);
  useEffect(() => {
    const previousPaymentType = previousPaymentTypeRef.current;
    previousPaymentTypeRef.current = values.paymentType;
    if (memberCreditApplicable) return;

    // Split payments populate the shared received/remaining fields. Reset all
    // split-derived state when the user changes back to a regular payment type.
    if (previousPaymentType === "SP" && values.paymentType !== "SP") {
      const payableAmount = parseFloat(
        totalAmountAfterInsuranceCoverage != null
          ? totalAmountAfterInsuranceCoverage
          : priceWithTax || values.totalPrice || 0
      );
      const receivedAmount = values.paymentType === "CO" ? 0 : payableAmount;

      setFieldValue("split", []);
      setFieldValue("paymentStatus", "F");
      setFieldValue("receivedAmount", receivedAmount.toFixed(2));
      setFieldValue("remainingAmount", "0.00");
      setTotalRecieved(0);
      return;
    }

    // Calculate the amount only while Split is the selected payment type.
    if (values.paymentType === "SP" && values.split.length) {
      const totalAmount = values.split.reduce((accumulator, currentValue) => {
        return accumulator + (parseFloat(currentValue.amount) || 0);
      }, 0);
      let e = {
        target: { value: totalAmount },
      };

      if (!memberPaidJoiningFees) {
        if (totalAmount == (totalAmountAfterInsuranceCoverage?totalAmountAfterInsuranceCoverage:values.totalPrice) + parseInt(values?.joiningFees)) {
          setFieldValue("paymentStatus", "F");
          handlePaidAmount(e);
        } else {
          setFieldValue("paymentStatus", "P");
          handlePaidAmount(e);
        }
      } else {
        if (
          totalAmount ==
          (totalAmountAfterInsuranceCoverage
            ? totalAmountAfterInsuranceCoverage
            : values.totalPrice)
        ) {
          setFieldValue("paymentStatus", "F");
          handlePaidAmount(e);
        } else {
          setFieldValue("paymentStatus", "P");
          handlePaidAmount(e);
        }
      }
    }
        if (values.receivedAmount) {
      // check if ! memberPaidJoiningFees add vallidation to be more than joiningFees
      // when user add received amount 10500 the joining fees will be taken and recieved amount for subscription will be
      //
    console.log({totalAmountAfterInsuranceCoverage,priceWithTax,values});
      if (
        values.receivedAmount == "0" &&
        !memberPaidJoiningFees &&
        values.paymentStatus == "P" &&
        !totalRecieved
      ) {
        setFieldValue(
          "remainingAmount",
          parseFloat(parseInt(totalAmountAfterInsuranceCoverage?totalAmountAfterInsuranceCoverage:priceWithTax) + parseInt(values?.joiningFees))
            .toFixed(2)
            .toString()
        );
      } else {
        setFieldValue(
          "remainingAmount",
          parseFloat((totalAmountAfterInsuranceCoverage?totalAmountAfterInsuranceCoverage:priceWithTax) - values.receivedAmount)
            .toFixed(2)
            .toString()
        );
      }
    }
    if (values.paymentType == "CO") {
      setFieldValue("paymentStatus", "F");
      setShowComReason(true);
    }
  }, [values]);
  useEffect(() => {
    if (
      memberGymByMembershipCardId &&
      membershipCardsScannerAction == "searchByCardScanning"
    ) {
      changeMemberByRFIDReader(memberGymByMembershipCardId);
    }
  }, [memberGymByMembershipCardId]);

  const changeMember = async (e) => {
    if (!e) {
      setFieldValue("user", null);
      setFieldValue("creditToUse", 0);
      setFieldValue("physicalPayment", 0);
      setSelectedMainMember(null);
      return;
    }
    setFieldValue("creditToUse", 0);
    setFieldValue("physicalPayment", 0);
    setFieldValue("user", { label: e?.label, value: e.value?.id });
    const voice = store.getState().voiceAdd || {};
    const voiceSaleEdit = Boolean(
      voice.editingDraftId && voice.prefill && voice.prefill.type === "sale"
    );
    dispatch(getMember(e.value.id, !voiceSaleEdit));
    if (gymFeaturesObject["joiningFees"]) {
      dispatch(checkIfMemberPaidJoinFees(e.value.id));
    }
    setSelectedMainMember(e);
  };

  const voicePrefill = useSelector((state) => state.voiceAdd && state.voiceAdd.prefill);
  const voiceDrafts = useSelector(
    (state) => (state.voiceAdd && state.voiceAdd.drafts) || []
  );
  const voiceSaleStarted = useRef(false);
  const voiceSaleLoaded = useRef(false);
  const voiceSaleKey =
    voicePrefill && voicePrefill.type === "sale" ? voicePrefill.id : "";

  useEffect(() => {
    voiceSaleStarted.current = false;
    voiceSaleLoaded.current = false;
  }, [voiceSaleKey]);

  useEffect(() => {
    if (voiceSaleStarted.current) return;
    if (!voicePrefill || voicePrefill.type !== "sale") return;
    const voiceFields = voicePrefill.fields || {};
    ["paymentStatus", "paymentType", "tax", "receivedAmount"].forEach((key) => {
      if (voiceFields[key] !== undefined && voiceFields[key] !== null) {
        setFieldValue(key, voiceFields[key]);
      }
    });
    if (saleDraftNeedsIdentity(voicePrefill)) {
      setFieldValue("requiredAttachment", true);
    }
    if (voiceFields.attachment) {
      setFieldValue("attachment", voiceFields.attachment);
    }
    const memberRef = voiceFields.member;
    if (!memberRef || (!memberRef.id && !memberRef.pending)) {
      if (saleDraftNeedsIdentity(voicePrefill)) {
        setMemberHasIdDocument(false);
      }
      return;
    }
    voiceSaleStarted.current = true;
    if (memberRef.pending) {
      setFieldValue("user", {
        label: memberRef.name,
        value: memberRef.pending,
      });
      setSelectedMainMember({
        label: memberRef.name,
        value: { id: memberRef.pending },
        pending: true,
      });
      setMemberHasIdDocument(false);
      return;
    }
    changeMember({
      label: memberRef.name,
      value: { id: memberRef.id },
    });
  }, [voicePrefill]);

  useEffect(() => {
    if (!voiceSaleStarted.current || !selectedMainMember) return;
    if (voiceSaleLoaded.current) return;
    const packs = lookupItems(voicePrefill && voicePrefill.fields && voicePrefill.fields.packages);
    const products = lookupItems(voicePrefill && voicePrefill.fields && voicePrefill.fields.products);
    if (!packs.length && !products.length) {
      voiceSaleLoaded.current = true;
      return;
    }
    let cancelled = false;
    const memberId =
      (selectedMainMember.value && selectedMainMember.value.id) ||
      selectedMainMember.id;

    const loadRows = async (url) => {
      try {
        const res = await api(url, {}, "get");
        return res && res.data && Array.isArray(res.data.data) ? res.data.data : [];
      } catch (error) {
        return [];
      }
    };

    (async () => {
      const fullPackages = [];
      for (const pack of packs) {
        const known = (packageData || []).find(
          (item) => String(item.id) === String(pack.id || pack.value)
        );
        if (known) {
          fullPackages.push(known);
          continue;
        }
        if (pack.id) {
          const rows = await loadRows(
            `package?page=1&limit=20&isActive=true&search=${encodeURIComponent(pack.name || "")}`
          );
          const found = rows.find((item) => String(item.id) === String(pack.id));
          if (found) {
            fullPackages.push(found);
            continue;
          }
        }
        fullPackages.push({
          ...voicePackageRow(pack, voiceDrafts),
          requiredAttachment:
            pack.requiredAttachment || saleDraftNeedsIdentity(voicePrefill),
        });
      }
      const fullProducts = [];
      for (const product of products) {
        const rows = await loadRows(
          `products?limit=20&page=1&name=${encodeURIComponent(product.name || "")}`
        );
        const found = rows.find((item) => String(item.id) === String(product.id));
        if (found) fullProducts.push(found);
      }
      if (cancelled) return;
      voiceSaleLoaded.current = true;
      if (fullPackages.length) {
        setSelectedPackages(
          fullPackages.map((item) => {
            const { trainer, trainer_name, createdAt, updatedAt, ...rest } = item;
            rest.assignableMembers = [selectedMainMember, ...(member && member.relations ? member.relations : [])];
            rest.member = memberId;
            rest.startDate = new Date();
            rest.poolAccessType = item.poolAccessType;
            return rest;
          })
        );
        setSelectedSaleServices((current) =>
          current.find((item) => item.value === 1)
            ? current
            : current.concat({ value: 1, label: "Subscription", show: true })
        );
      }
      if (fullProducts.length) {
        setSelectedProducts(
          fullProducts.map((item) => ({
            ...item,
            assignableMembers: [selectedMainMember, ...(member && member.relations ? member.relations : [])],
            member: memberId,
          }))
        );
        setSelectedSaleServices((current) =>
          current.find((item) => item.value === 2)
            ? current
            : current.concat({ value: 2, label: "Product", show: true })
        );
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [selectedMainMember, voicePrefill, voiceDrafts]);

  // ── Member async autocomplete ───────────────────────────────────────────────
  // Replaces the old pattern of pre-loading all members (up to 10,000+) into
  // Redux before opening the modal. Now searches server-side on every keystroke
  // (min 2 chars) and returns at most 50 matches. The option shape is kept
  // identical to the legacy membersList so changeMember() works unchanged.
  const loadMemberOptions = async (inputValue) => {
    if (!inputValue || inputValue.trim().length < 2) return [];
    try {
      const gym = JSON.parse(localStorage.getItem("connectToFitGymPanelUser")).gym;
      const res = await api(
        `memberAll?gym=${gym}&search=${encodeURIComponent(inputValue.trim())}`,
        {},
        "get"
      );
      if (!res || res.status !== 200 || !res.data?.data) return [];
      return res.data.data.map((item) => ({
        label: `${item.name}-${item.phone ? item.phone : "No Phone"}`,
        value: { id: item.id, image: item.image },
        phone: item.phone,
      }));
    } catch {
      return [];
    }
  };
  // ───────────────────────────────────────────────────────────────────────────
  const changeMemberByRFIDReader = (member) => {
    changeMember({
      label: member.name,
      value: member,
    });
  };
  const handlePackChange = (e, idx, prop) => {
    const packs = selectedPackages;
    let pack = selectedPackages[idx];
    if(prop==="member" &&membersRelations.find((el)=>el.id===parseInt(e.target.value)) ){
      const relation=membersRelations.find((el)=>el.id)
    if(relation?.metaData && relation?.metaData?.insuranceDetails&& relation?.metaData?.insuranceDetails?.hasInsurance=="yes"){
        const {Copayment,insuranceCardNumber,insuranceCompany}=relation?.metaData?.insuranceDetails;
        setFieldValue("insuranceDetails",{Copayment,insuranceCardNumber,insuranceCompany});
        setInsuranceDetails({Copayment,insuranceCardNumber,insuranceCompany});
      }
    }
    if(prop=="assignedTrainer" && settings?.followupProgram?.automaticInstructorsRotation){
      pack["isRotationChanged"]=parseInt(e.target.value) !== firstInstructorInRotationList?.id ?true:false
      pack[`${prop}`] = parseInt(e.target.value)
    }
    else if(prop == "numberOfPlayers"){
      const packPrice=pack.prices.find(p=>p.numberOfPeople == parseInt(e))
      pack.price=packPrice?.price
      pack[prop]=parseInt(e)

    }else {
      prop === "startDate"
      ? (pack[`${prop}`] = e)
      : prop === "member" || prop === "extendDuration"
      ? (pack[`${prop}`] = parseInt(e.target.value))
      : (pack[`${prop}`] = e.target.value);
    }
    packs[idx] = pack;
    setSinglePackageTouched(!singlePackageTouched);
    setSelectedPackages(packs);
  };
  const handleProductChange = (product, quantity) => {
    let packs = selectedProducts;
    let pack = { ...product };
    pack[`quantity`] = quantity;
    packs = packs.map((el) => {
      if (el.id == product.id) {
        return { ...product, member: el.member };
      }
      return el;
    });
    setSingleProductTouched(!singleProductTouched);
    setSelectedProducts(packs);
  };

  const handlePackageDiscountChange = (id, discount) => {
    let packs = selectedPackages;
    packs = packs.map((el) => {
      if (el.id == id) {
        el[`discount`] = discount;
      }
      return el;
    });
    setSinglePackageTouched(!singlePackageTouched);
    console.log(
      { selectedPackages },
      "selectedPackagesselectedPackagesselectedPackages"
    );
    setSelectedPackages(packs);
  };

  const handleProductDiscountChange = (id, discount) => {
    let packs = selectedProducts;
    packs = packs.map((el) => {
      if (el.id == id) {
        el[`discount`] = discount;
      }
      return el;
    });
    setSingleProductTouched(!singleProductTouched);
    setSelectedProducts(packs);
  };
  const handlePaidAmount = (e) => {
   if (e.target.value < 0) {
    setFieldValue("receivedAmount", 0);
    toastr.error("Received amount cannot be negative.");
    return;
    }
    if(totalAmountAfterInsuranceCoverage){
      if (parseFloat(e.target.value) > totalAmountAfterInsuranceCoverage) {
        toastr.error("Received amount cannot be more than total price");
        return;
      }
    } else if (!memberPaidJoiningFees) {
      if (
        parseFloat(e.target.value) >
        parseInt(totalAmountAfterInsuranceCoverage?totalAmountAfterInsuranceCoverage:priceWithTax) + parseInt(values?.joiningFees)
      ) {
        toastr.error("Received amount cannot be more than total price");
        return;
      }
    }  else if (parseFloat(e.target.value) > priceWithTax) {
      toastr.error("Received amount cannot be more than total price");
      return;
    }

    console.log({ memberPaidJoiningFees, e });
    if (!memberPaidJoiningFees && values?.paymentStatus == "P") {
      if (e.target.value) setTotalRecieved(parseFloat(e.target.value));
      else {
        setTotalRecieved(0);
        setFieldValue("receivedAmount", "0");
      }
    } else {
      if (e.target.value) setFieldValue("receivedAmount", e.target.value);
      else setFieldValue("receivedAmount", "0");
    }
  };
  // const handleFileChange = async (event) => {
  //   const file = event;
  //   setSelectedFile(file);
  //   getFileUrl({ selectedFile: file });
  // };
  // const getFileUrl = ({ selectedFile }) => {
  //   if (selectedFile) {
  //     const reader = new FileReader();
  //     reader.onload = async (event) => {
  //       let data = {
  //         fileName: selectedFile.name,
  //         source: event.target.result,
  //         folder: "attchments",
  //         type: selectedFile.type,
  //       };
  //       var url = await api(`file`, data, "post");
  //       if (url.data.status === 201) {
  //         setContent(url.data.data);
  //         setFieldValue("attachment", url.data.data);
  //       }
  //     };
  //     reader.readAsDataURL(selectedFile);
  //   }
  // };
  

  useEffect(() => {
    if (!memberPaidJoiningFees) {
      if (totalRecieved) {
        console.log("trigered", totalRecieved);
        if (parseInt(totalRecieved) < parseInt(values?.joiningFees)) {
          toastr.error(
            "Received amount should be  at least more than joining Fees"
          );
          return;
        }
        setFieldValue(
          "receivedAmount",
          `${parseInt(totalRecieved) - parseInt(values?.joiningFees)}`
        );
      } else {
        if (values.paymentType !== "CO" && values.paymentStatus == "P") {
          setFieldValue("receivedAmount", "0");
        }
      }
    }
  }, [totalRecieved]);
  const handleImportSales = async () => {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = ".xls,.xlsx";

    input.addEventListener("change", async (event) => {
      const file = event.target.files[0];
      if (!file) {
        toastr.error("No file selected");
        return;
      }
      const formData = new FormData();
      formData.append("file", file);

      try {
        setIsImportDataLoading(true);
        const response = await store.dispatch(importSales(formData));
      } catch (error) {
        console.error("Error while importing packages data:", error);
        toastr.error("Error while importing packages data");
      }
      setIsImportDataLoading(false);
    });
    input.click();
  };
  const handleDownloadTemplate = async () => {
    try {
      const response = await store.dispatch(downloadSalesTemplate());
      //create a temporary URL to the file blob
      const url = window.URL.createObjectURL(new Blob([response.data]));

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "sales-template.xlsx");

      document.body.appendChild(link);
      link.click();

      // Clean up
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error while downloading sales template:", error);
      toastr.error("Error while downloading sales template");
    }
  };

  const discountSubscriptionOnChange = (value, id) => {
    if (
      (loginUser.role == "STAFF" && permissions["S-DIC-ADD-20"]) ||
      (subAdminType == "SUB_ADMIN" && subAdminPermissions["S-DIC-ADD-20"])
    ) {
      if (value > 20) {
        handlePackageDiscountChange(id, 0);
        toastr.error("Max discount is 20");
      } else {
        handlePackageDiscountChange(id, value);
      }
    } else {
      handlePackageDiscountChange(id, value);
    }
  };

  const discountProductOnChange = (value, id) => {
    if (
      (loginUser.role == "STAFF" && permissions["S-DIC-ADD-20"]) ||
      (subAdminType == "SUB_ADMIN" && subAdminPermissions["S-DIC-ADD-20"])
    ) {
      if (value && value > 20) {
        handleProductDiscountChange(id, 0, "discount");
        toastr.error("Max discount is 20");
      } else {
        handleProductDiscountChange(id, value, "discount");
      }
    } else {
      handleProductDiscountChange(id, value, "discount");
    }
  };

  useEffect(() => {
    if (!discountSaleCalculatorOpen) {
      setSelectedPackageForDiscountCalculator(null);
      setSelectedProductForDiscountCalculator(null);
    }
  }, [discountSaleCalculatorOpen]);


  const voiceNeedsIdentityDoc = saleDraftNeedsIdentity(voicePrefill);
  const showVoiceIdentityUpload =
    voiceNeedsIdentityDoc && memberHasIdDocument !== true;

  return (
    <>
      <div className=" bg-white card-panel">
        <div className="basic-info">
          <div className="info-title with-border">
            <Title
              title="Add Sale"
              subtitlestyle="ctf-tx-secondary"
              subtitle="Add sales for the member"
            />
          </div>
        </div>
        {showVoiceIdentityUpload ? (
          <div
            className="mx-4 mb-3 p-3"
            style={{
              background: "#fff4f4",
              border: "1px solid rgba(192, 16, 19, 0.2)",
              borderRadius: 12,
            }}
          >
            <h5 className="mb-2" style={{ color: "#8a1216", fontWeight: 700 }}>
              Member identity document required
            </h5>
            <p className="mb-3" style={{ color: "#8a1216" }}>
              Upload or capture the document below, then save to return to Add
              with Voice.
            </p>
            <UploadOrCapture
              label="Upload Member's Identity"
              folder="memberDocs"
              setSelectedFile={(file) => {
                setSelectedFile(file);
                if (voicePrefill && voicePrefill.id) {
                  stashVoiceSaleIdentity(voicePrefill.id, { file });
                }
              }}
              onFileSelect={(url) => {
                setContent(url);
                setFieldValue("attachment", url);
                setFieldValue("requiredAttachment", true);
                if (voicePrefill && voicePrefill.id) {
                  stashVoiceSaleIdentity(voicePrefill.id, { url });
                }
              }}
            />
            <button
              type="button"
              className="btn btn-medium mt-2"
              disabled={!values.attachment}
              onClick={async () => {
                const memberId =
                  (values.user && (values.user.value || values.user.id)) ||
                  (voicePrefill.fields &&
                    voicePrefill.fields.member &&
                    voicePrefill.fields.member.id);
                await persistStashedSaleIdentity(
                  { ...voicePrefill, fields: { ...voicePrefill.fields, attachment: values.attachment } },
                  memberId
                );
                saveVoiceDraftEdit({
                  ...values,
                  requiredAttachment: true,
                  attachment: values.attachment,
                });
              }}
            >
              Save and return to Voice Add
            </button>
          </div>
        ) : null}
        <div className="trainer-gender-default-wrapper blk-padding-y">
          <div className="info-title pb-0 d-flex align-items-center justify-content-between">
            <Title title={"Assign sale to user"} />
            {gymConfig?.importData?.enabled &&
              (loginUser.role === "STAFF" ? permissions["S-IMP"] : true) && (
                <li className="dropdown filter-list-element">
                  <CustomDropdown
                    dropdownitems={importDropdownListItems}
                    maintitle="Import data"
                    subtitle=" "
                    handleImportSales={handleImportSales}
                    handleDownloadTemplate={handleDownloadTemplate}
                  />
                </li>
              )}
          </div>
          <div
            className="info blk-padding-y pb-0"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Row
              md={12}
              className="selected-classes-box"
              id="sale-upper-outer-container"
            >
              <Row
                md={12}
                className="selected-classes-box"
                style={{ height: "100%", display: "flex" }}
              >
                <Row
                  xs={12}
                  style={{ width: "100%", justifyContent: "center" }}
                >
                  <Col
                    md={6}
                    className="d-flex align-items-center"
                    style={{ marginTop: "26px" }}
                  >
                    {gymConfig?.gates?.enabled &&
                      gymConfig?.gates?.accessBy == "RFIDCards" &&
                      selectedMainMember && (
                        <img
                          src={
                            selectedMainMember.image
                              ? selectedMainMember.image
                              : require("../../assets/images/no-image_user.jpg")
                          }
                          className="member-img-sm c-pointer"
                          alt="user"
                          onClick={() => {
                            setIsMemberInfoModalOpen(true);
                          }}
                        />
                      )}
                    <FormGroup
                      className="custom-inputs select-box mb-md-0 custom-add-sale-input"
                      style={{ height: "52px" }}
                    >
                      <AsyncSelect
                        name="user"
                        loadOptions={loadMemberOptions}
                        className={`form-control p-0 h-100 bg-grey ${errors.user &&
                          touched.use &&
                          "is-invalid"} d-flex align-items-center`}
                        styles={customStyle}
                        defaultValue={
                          member ? { value: { id: member.id, image: member.image }, label: member.name } : null
                        }
                        value={values.user || selectedMainMember}
                        style={{
                          color: "#F5F7F8",
                          background: "#F5F7F8",
                          backgroundColor: "#F5F7F8",
                        }}
                        onChange={(e) => changeMember(e)}
                        isClearable
                        isDisabled={
                          addToBookingListModal ||
                          bookAppointmentModal ||
                          selectedPackages.length
                        }
                        placeholder="Type name or phone to search..."
                        noOptionsMessage={({ inputValue }) =>
                          inputValue && inputValue.length >= 2
                            ? "No members found"
                            : "Type at least 2 characters to search"
                        }
                        cacheOptions
                      />
                      <Label
                        for="user"
                        className="grey-background"
                        style={{
                          background: "#F5F7F8",
                          mixBlendMode: "normal",
                        }}
                      >
                        Assgin Sale to Member
                      </Label>
                      {errors.user && touched.user ? (
                        <div className="invalid-feedback">{`${errors.user}`}</div>
                      ) : null}
                    </FormGroup>
                    {gymConfig?.gates?.enabled &&
                      gymConfig?.gates?.accessBy == "RFIDCards" && (
                        <button
                          type="button"
                          style={{
                            padding: "9px",
                            fontSize: "unset",
                            lineHeight: "unset",
                          }}
                          className="outlined-button-custom ml-1"
                          form="relation-form"
                          onClick={() => {
                            dispatch(
                              setMembershipCardsScannerPopupOpen(
                                true,
                                "searchByCardScanning"
                              )
                            );
                          }}
                        >
                          Search By Card
                        </button>
                      )}
                  </Col>
                  {
                    values.fromBooking?
                        <>
                        <Col md={3} style={{ marginTop: "26px" }}>
                          <FormGroup className="custom-inputs select-box mb-md-0 custom-add-sale-input">
                            <Label className="grey-background" style={{ marginBottom: "8px" }}>
                              Service Details
                            </Label>
                            <div style={{
                              display: "flex",
                              gap: "12px",
                              padding: "12px",
                              // background: "#FFFFFF",
                              border: "1px solid #E5E7EB",
                              borderRadius: "6px"
                            }}>
                              {/* Service Name - Takes more space */}
                              <div style={{
                                flex: 3,
                                display: "flex",
                                flexDirection: "column",
                                gap: "4px"
                              }}>
                                <span style={{
                                  fontSize: "10px",
                                  fontWeight: "600",
                                  color: "#6B7280",
                                  textTransform: "uppercase"
                                }}>
                                  Service
                                </span>
                                <span style={{
                                  fontSize: "12px",
                                  fontWeight: "500",
                                  color: "#1F2937"
                                }}>
                                  {values?.bookingData?.serviceName||"No Chosen Yet"}
                                </span>
                              </div>
                              
                              {/* Divider */}
                              <div style={{
                                width: "1px",
                                background: "#E5E7EB"
                              }}></div>
                              
                              {/* Number of Players - Takes less space */}
                              <div style={{
                                flex: 1,
                                display: "flex",
                                flexDirection: "column",
                                gap: "4px"
                              }}>
                                <span style={{
                                  fontSize: "12px",
                                  fontWeight: "600",
                                  color: "#6B7280",
                                  textTransform: "uppercase"
                                }}>
                                  Players
                                </span>
                                <span style={{
                                  fontSize: "14px",
                                  fontWeight: "500",
                                  color: "#1F2937"
                                }}>
                                  {values?.bookingData?.numberOfPlayers}
                                </span>
                              </div>
                            </div>
                          </FormGroup>
                        </Col>
                        <Col md={3} style={{ marginTop: "26px" }}>
                          <FormGroup
                                className="custom-inputs select-box mb-md-0 custom-add-sale-input sale-package-picker"
                                style={{ height: "59px" }}
                              >
                                <button
                                  type="button"
                                  id="package-selector"
                                  className="sale-package-picker__control"
                                  disabled={
                                    isMemberLoading || bookingPackagesLoading
                                  }
                                  onClick={(event) => {
                                    if (packageMenuBox) {
                                      setPackageMenuBox(null);
                                      return;
                                    }
                                    const rect = event.currentTarget.getBoundingClientRect();
                                    const width = Math.min(
                                      460,
                                      window.innerWidth - 24,
                                    );
                                    setPackageMenuBox({
                                      top: rect.bottom + 4,
                                      left: Math.max(
                                        12,
                                        Math.min(rect.right - width, window.innerWidth - width - 12),
                                      ),
                                      width,
                                    });
                                  }}
                                >
                                  {bookingPackagesLoading
                                    ? "Loading packages..."
                                    : "Select"}
                                </button>
                                {packageMenuBox
                                  ? createPortal(
                                      <div
                                        className="sale-package-picker__menu"
                                        style={{
                                          top: packageMenuBox.top,
                                          left: packageMenuBox.left,
                                          width: packageMenuBox.width,
                                        }}
                                      >
                                        {servicePackages.length ? (
                                          servicePackages.map((pack) => (
                                            <button
                                              type="button"
                                              key={pack.pkgId}
                                              className="sale-package-picker__option"
                                              onClick={() => {
                                                setSinglePackage(
                                                  bookingPackages.find(
                                                    (item) => item.pkgId == pack.pkgId,
                                                  ),
                                                );
                                                setPackageMenuBox(null);
                                              }}
                                            >
                                              {pack.name}
                                            </button>
                                          ))
                                        ) : (
                                          <div className="sale-package-picker__empty">
                                            No packages
                                          </div>
                                        )}
                                      </div>,
                                      document.body,
                                    )
                                  : null}

                                <Label
                                  for={`package`}
                                  style={{
                                    background: "#F5F7F8",
                                    mixBlendMode: "normal",
                                  }}
                                  className="grey-background"
                                >
                                  Select Service Package
                                </Label>
                          </FormGroup>
                        </Col>
                        </>
                        :
                        <>
                        <Col md={6} style={{ marginTop: "26px" }}>
                        <Input
                          type="text"
                          value={inputValue}
                          onChange={handleInputChange}
                          onClick={handleInputClick}
                          placeholder="Select services/products"
                          style={{ height: "100%" }}
                        />
                        {showOptions && (
                          <div
                            style={{
                              position: "absolute",
                              zIndex: "1",
                              width: "100%",
                            }}
                          >
                            <ListGroup>
                              {options
                                .filter((el) => el.show)
                                .map((option, index) => (
                                  <ListGroupItem
                                    key={index}
                                    onClick={() => handleOptionClick(option)}
                                    style={{
                                      fontSize: "19px",
                                      padding: "0.90rem 1.25rem",
                                      width: " 94%",
                                      cursor: "pointer",
                                    }}
                                  >
                                    {option.label}
                                  </ListGroupItem>
                                ))}
                            </ListGroup>
                          </div>
                        )}
                        </Col>
                        {selectedSaleServices.find((el) => el?.value == 1) && (
                          <Col md={6} style={{ marginTop: "26px" }}>
                            <FormGroup
                              className="custom-inputs select-box mb-md-0 custom-add-sale-input"
                              style={{ height: "52px" }}
                            >
                              <Input
                                type="select"
                                value=""
                                disabled={isMemberLoading}
                                className={`form-control form-control p-0 h-100 ${errors.packages &&
                                  "is-invalid"} d-flex align-items-center`}
                                name={`package`}
                                style={{ background: "#f5f7f8" }}
                                id="package-selector"
                                onChange={(e) => {
                                  setSinglePackage(
                                    packageData.find((p) => p.id == e.target.value)
                                  );
                                }}
                              >
                                <option value={null}>{"Select"}</option>
                                {gymPackages.map((pack, idx) => {
                                  return <option value={pack.id} key={pack.id}>{pack.name}</option>;
                                })}
                              </Input>

                              <Label
                                for={`package`}
                                style={{
                                  background: "#F5F7F8",
                                  mixBlendMode: "normal",
                                }}
                                className="grey-background"
                              >
                                Select Subscription
                              </Label>
                            </FormGroup>
                          </Col>
                        )}
                        {selectedSaleServices.find((el) => el?.value == 3) && (
                          <Col md={6} style={{ marginTop: "26px" }}>
                            <FormGroup
                              className="custom-inputs select-box mb-md-0 custom-add-sale-input"
                              style={{ height: "52px" }}
                            >
                              <Input
                                type="select"
                                value=""
                                disabled={isMemberLoading}
                                className={`form-control form-control p-0 h-100 ${errors.packages &&
                                  "is-invalid"} d-flex align-items-center`}
                                name={`package`}
                                style={{ background: "#f5f7f8" }}
                                id="package-selector"
                                onChange={(e) => {
                                  setSinglePackage(
                                    packageData.find((p) => p.id == e.target.value)
                                  );
                                }}
                              >
                                <option value={null}>{"Select"}</option>
                                {servicePackages.map((pack, idx) => {
                                  return <option value={pack.id} key={pack.id}>{pack.name}</option>;
                                })}
                              </Input>

                              <Label
                                for={`package`}
                                style={{
                                  background: "#F5F7F8",
                                  mixBlendMode: "normal",
                                }}
                                className="grey-background"
                              >
                                Select Service Package
                              </Label>
                            </FormGroup>
                          </Col>
                        )}
                       </>
                  }
                  {showProductDialog && (
                    <Modal
                      isOpen={showProductDialog}
                      toggle={() => {
                        setShowProductDialog(false);
                      }}
                      centered={true}
                      className="product-pop-up"
                    >
                      <ProductComponentV2
                        setSingleProduct={setSingleProduct}
                        selectedProducts={selectedProducts}
                        selectedPackages={selectedPackages}
                        handleProductChange={handleProductChange}
                        setToDeleteProduct={setToDeleteProduct}
                        singleProductTouched={singleProductTouched}
                        setShowProductDialog={setShowProductDialog}
                        tax={
                          formikProps.values.tax ? formikProps.values.tax : 0
                        }
                        setSelectedSaleServices={setSelectedSaleServices}
                        setSelectedProducts={setSelectedProducts}
                      />
                    </Modal>
                  )}

                  {
                    // check if no subscriptions or products :
                    <Row
                      xs={12}
                      className="selected-classes-box"
                      id="no-border"
                    >
                      {selectedPackages.length == 0 &&
                        selectedProducts.length == 0 && (
                          <Row xs={12} className="packages-container-sale-form">
                            <p className="no-classes-message">
                              No subscriptions or Products added yet!
                            </p>
                          </Row>
                        )}
                      {// selected products
                      selectedProducts && selectedProducts.length > 0 && (
                        <>
                          <Row xs={12} className="packages-container-sale-form">
                            <Row className="w-100 p-0 py-2 m-0 mobile-d-none">
                              <Col lg={3} md={3}>
                                <h5>Product</h5>
                              </Col>
                              <Col lg={3} md={3} className="ml-3">
                                <h5>Expiry Date</h5>
                              </Col>
                              <Col lg={3} md={3}>
                                <h5>Quantity</h5>
                              </Col>
                              <Col lg={2} id="discount-header">
                                <h5>Discount %</h5>
                              </Col>
                            </Row>
                            {selectedProducts.map((item, index) => {
                              return (
                                <Row
                                  key={item.id}
                                  xs={12}
                                  md={12}
                                  className={`selected-class-row d-flex justify-content-between ${
                                    index % 2 !== 0 ? "bg-grey" : ""
                                  }`}
                                  id="selected-package-row"
                                >
                                  <Col lg={3} md={3} xs={12}>
                                    <p>
                                      {item.name}{" "}
                                      <span>
                                        ({item.price}{" "}
                                        {
                                          JSON.parse(
                                            localStorage.getItem(
                                              "connectToFitGymPanelUser"
                                            )
                                          )?.currency
                                        }
                                        )
                                      </span>
                                    </p>
                                  </Col>

                                  <Col xs={12} md={3} lg={3}>
                                    <p>
                                      {item?.expiryDate
                                        ? moment(item.expiryDate).format(
                                            "DD-MM-YYYY"
                                          )
                                        : "Not Available"}
                                    </p>
                                    {/* <FormGroup
                                      className="custom-inputs select-box mb-md-0 custom-add-sale-input d-flex align-items-center"
                                      style={{ height: "52px" }}
                                    >
                                      <Input
                                        type="text"
                                        className={`form-control form-control p-0 h-100 d-flex align-items-center`}
                                        name={`package`}
                                        disabled={true}
                                        defaultValue={
                                          item?.expiryDate
                                            ? moment(item.expiryDate).format(
                                                "YYYY-MM-DD"
                                              )
                                            : "Not Available"
                                        }
                                        id="select-specific-member"
                                      ></Input>
                                    </FormGroup> */}
                                  </Col>

                                  <Col xs={12} md={3} lg={3}>
                                    <p>{selectedProducts[index]?.quantity}</p>
                                    {/* <FormGroup
                                      className="custom-inputs select-box mb-md-0 custom-add-sale-input d-flex align-items-center"
                                      style={{ height: "52px" }}
                                    >
                                      <Input
                                        type="number"
                                        className={`form-control form-control p-0 h-100 d-flex align-items-center`}
                                        name={`product`}
                                        // defaultValue={ selectedProducts[index].quantity}
                                        value={
                                          selectedProducts[index]?.quantity
                                        }
                                        // onChange={(e) => {
                                        //   let maxQuantity =
                                        //     selectedProducts[index]
                                        //       .availableInStock;
                                        //   if (
                                        //     parseInt(e.target.value) >
                                        //     maxQuantity
                                        //   ) {
                                        //     toastr.error(
                                        //       `The Available Quantity for ${selectedProducts[index].name} is ${selectedProducts[index].availableInStock}`
                                        //     );

                                        //     handleProductChange(
                                        //       { target: { value: 0 } },
                                        //       index,
                                        //       "quantity"
                                        //     );
                                        //   } else {
                                        //     handleProductChange(
                                        //       e,
                                        //       index,
                                        //       "quantity"
                                        //     );
                                        //   }
                                        // }}
                                        id="select-specific-member"
                                      ></Input>
                                    </FormGroup> */}
                                  </Col>
                                  <Col
                                    xs={12}
                                    md={6}
                                    lg={2}
                                    className="discount-product-field-col"
                                  >
                                    <FormGroup
                                      className="custom-inputs select-box mb-md-0 custom-add-sale-input d-flex align-items-center"
                                      style={{ height: "52px" }}
                                    >
                                      {(loginUser.role == "STAFF" &&
                                        !permissions["S-DIC-MNG"] &&
                                        !permissions["S-DIC-ADD-20"]) ||
                                      (subAdminType == "SUB_ADMIN" &&
                                        !subAdminPermissions["S-DIC-MNG"] &&
                                        !subAdminPermissions[
                                          "S-DIC-ADD-20"
                                        ]) ? null : (
                                        <>
                                          <Input
                                            type="number"
                                            className={`form-control form-control p-0 h-100 ${errors.user &&
                                              touched.use &&
                                              "is-invalid"} d-flex align-items-center`}
                                            name={`package`}
                                            placeholder="Discount"
                                            value={
                                              selectedProducts[index]?.discount
                                            }
                                            onChange={(e) =>
                                              discountProductOnChange(
                                                e.target.value,
                                                selectedProducts[index].id
                                              )
                                            }
                                            id="discount-product-percent-field"
                                          ></Input>
                                          <button
                                            className="btn-info"
                                            type="button"
                                            style={{
                                              marginRight: "50px",
                                              width: "44px",
                                              height: "36px",
                                            }}
                                            onClick={() => {
                                              setDiscountSaleCalculatorOpen(
                                                true
                                              );
                                              setSelectedProductForDiscountCalculator(
                                                selectedProducts[index]
                                              );
                                            }}
                                          >
                                            Calc %
                                          </button>
                                        </>
                                      )}
                                    </FormGroup>
                                  </Col>
                                  <Col
                                    xs={12}
                                    md={1}
                                    lg={1}
                                    id="delete-icon-sale"
                                  >
                                    <span
                                      onClick={() => {
                                        setToDeleteProduct(item?.id);
                                      }}
                                      style={{
                                        color: "#E4E7Eb",
                                        cursor: "pointer",
                                      }}
                                    >
                                      {ComonIcons.delete}
                                    </span>
                                  </Col>
                                </Row>
                              );
                            })}
                            {discountSaleCalculatorOpen &&
                              selectedProductForDiscountCalculator && (
                                <DiscountSaleCalculator
                                  originalAmount={
                                    selectedProductForDiscountCalculator.price *
                                    selectedProductForDiscountCalculator.quantity
                                  }
                                  discount={
                                    selectedProductForDiscountCalculator.discount
                                  }
                                  discountSaleCalculatorOpen={
                                    discountSaleCalculatorOpen
                                  }
                                  setDiscountSaleCalculatorOpen={
                                    setDiscountSaleCalculatorOpen
                                  }
                                  setDiscount={(v) =>
                                    discountProductOnChange(
                                      v,
                                      selectedProductForDiscountCalculator.id
                                    )
                                  }
                                />
                              )}
                          </Row>

                          {/** Assigned Seller */}
                          <Row className="mt-4">
                            {" "}
                            <Title title={"Assign product sale to : "} />
                          </Row>
                          <Row xs={12} className="product-assign-seller mb-3">
                            <Row style={{ width: "47%", margin: "5px" }}>
                              <Col
                                md={4}
                                lg={4}
                                // style={{
                                //   height: "40px",
                                //   padding: "1rem",
                                // }}
                              >
                                <Field
                                  type="radio"
                                  value="M"
                                  name="assignSeller"
                                  id="femaleRadio"
                                />
                                <label for="femaleRadio">Assign to me</label>
                              </Col>
                              <Col
                                md={values.assignSeller !== "S" ? 4 : 4}
                                lg={4}
                              >
                                <Field
                                  type="radio"
                                  value="S"
                                  name="assignSeller"
                                  id="maleRadio"
                                />
                                <label for="maleRadio">Assign to staff </label>
                              </Col>
                              <Col
                                md={values.assignSeller !== "T" ? 4 : 4}
                                lg={4}
                              >
                                <Field
                                  type="radio"
                                  value="T"
                                  name="assignSeller"
                                  id="trainerRadio"
                                />
                                <label for="trainerRadio">
                                  Assign to Trainer{" "}
                                </label>
                              </Col>
                            </Row>

                            <Col>
                              {values.assignSeller == "S" ? (
                                <Col md={6}>
                                  <FormGroup
                                    className="custom-inputs select-box mb-md-0 custom-add-sale-input d-flex align-items-center"
                                    style={{ height: "40px" }}
                                  >
                                    <Input
                                      type="select"
                                      className={`form-control form-control p-0 h-100 ${errors.user &&
                                        touched.use &&
                                        "is-invalid"} d-flex align-items-center`}
                                      name={`package`}
                                      onChange={(e) => {
                                        setFieldValue(
                                          "assignedUser",
                                          e.target.value
                                        );
                                      }}
                                      id="select-specific-member"
                                    >
                                      <option value={null}>{"Select"}</option>;
                                      {staffs?.map((el) => {
                                        return (
                                          <option value={el.id}>
                                            {el.name}
                                          </option>
                                        );
                                      })}
                                    </Input>
                                  </FormGroup>
                                </Col>
                              ) : null}

                              {values.assignSeller == "T" ? (
                                <Col md={6} className="mb-3">
                                  <FormGroup
                                    className="custom-inputs select-box mb-md-0 custom-add-sale-input d-flex align-items-center"
                                    style={{ height: "40px" }}
                                  >
                                    <Input
                                      type="select"
                                      className={`form-control form-control p-0 h-100 ${errors.user &&
                                        touched.use &&
                                        "is-invalid"} d-flex align-items-center`}
                                      name={`package`}
                                      onChange={(e) => {
                                        setFieldValue(
                                          "assignedUser",
                                          e.target.value
                                        );
                                      }}
                                      id="select-specific-member"
                                    >
                                      <option value={null}>{"Select"}</option>;
                                      {trainers?.map((el) => {
                                        return (
                                          <option value={el.user_id}>
                                            {el.user_name}
                                          </option>
                                        );
                                      })}
                                      {/* {selectedPackages[
                                      index
                                    ].assignableMembers?.map((rel, idx) => {
                                      return (
                                        <option value={rel.id}>
                                          {rel.name}
                                        </option>
                                      );
                                    })} */}
                                    </Input>
                                  </FormGroup>
                                </Col>
                              ) : null}
                            </Col>
                          </Row>
                          {!values.assignSeller ? (
                            <div className="invalid-feedback ml-5 mb-2">{`Assign Sellere is Required`}</div>
                          ) : null}
                        </>
                      )}
                      {selectedPackages && selectedPackages.length > 0 && (
                        <>
                          <Row xs={12} className="packages-container-sale-form">
                            <Row className="selected-class-row-packages-title w-100 p-0 py-2 m-0">
                              <Col lg={2}>
                                <h5>Package</h5>
                              </Col>
                              <Col lg={2}>
                                <h5>Member</h5>
                              </Col>
                              <Col lg={2}>
                                <h5>Start Date</h5>
                              </Col>
                              <Col lg={2}>
                                <h5>End Date</h5>
                              </Col>
                              <Col lg={2} id="discount-header">
                                <h5>Discount</h5>
                              </Col>
                              <Col lg={2}>
                                <h5>Assigned Trainer</h5>
                              </Col>
                              {
                                followupProgramEnabled &&
                                <Col lg={2}>
                                  <h5>Follow-up Program</h5>
                                </Col>
                              }
                              <Col lg={1}><span></span></Col>
                            </Row>
                              {selectedPackages.map((item, index) => {
                                return (
                                  <Row
                                    key={`${item.id}-${index}`}
                                    xs={12}
                                    md={12}
                                    className={`selected-class-row selected-class-row-packages d-flex justify-content-between ${
                                      index % 2 !== 0 ? "bg-grey" : ""
                                    }`}
                                    id="selected-package-row"
                                  >
                                    <Col
                                      lg={2}
                                      md={6}
                                      // sm={6}
                                      xs={12}
                                      className="selected-class-name d-flex align-items-center "
                                    >
                                    <div style={{ display: "flex",flexDirection: "column",}}>
                                      <p className="mb-1 mt-3">
                                        {item.name}{" "}
                                        <span>
                                          ({item.price}{" "}
                                          {
                                            JSON.parse(
                                              localStorage.getItem(
                                                "connectToFitGymPanelUser"
                                              )
                                            ).currency
                                          }
                                          )
                                        </span>
                                      </p>
                                      {gymConfig?.manageMemberships?.appointmentMemberships?.enabled &&
                                      gymConfig?.manageMemberships?.appointmentMemberships?.ptGroupPricing &&
                                      gymConfig?.manageMemberships?.appointmentMemberships?.ptGroupPricing?.enabled &&
                                      item.planType === "pt" &&
                                      item?.prices?.length > 0 && (
                                        <div style={{ marginBottom: 14 }}>

                                          {/* Max label */}
                                          <p style={{ fontSize: 11, color: "#666", margin: 0 }}>
                                            Max Number of People ({item.prices.length})
                                          </p>

                                          {/* Controls */}
                                          <div style={{ display: "flex", alignItems: "center", gap: "43px"}}>

                                            {/* + Button */}
                                            <p
                                              style={{
                                                fontSize: 20,
                                                fontWeight: "bold",
                                                color: item.numberOfPlayers >= item.prices.length ? "#ccc" : "rgb(32 88 18)",
                                                cursor: item.numberOfPlayers >= item.prices.length ? "not-allowed" : "pointer",
                                                margin: 0,
                                              }}
                                              onClick={() => {
                                                if (item.numberOfPlayers >= item.prices.length) return;
                                                handlePackChange(
                                                  item.numberOfPlayers ? item.numberOfPlayers + 1 : 2,
                                                  index,
                                                  "numberOfPlayers"
                                                );
                                              }}
                                            >
                                              +
                                            </p>

                                            {/* Current Count */}
                                            <p style={{ fontSize: 14, margin: "0 8px", minWidth: 20, textAlign: "center" }}>
                                              {item.numberOfPlayers || 1}
                                            </p>

                                            {/* - Button */}
                                            <p
                                              style={{
                                                fontSize: 20,
                                                fontWeight: "bold",
                                                color: item.numberOfPlayers <= 1 ? "#ccc" : "rgb(32 88 18)",
                                                cursor: item.numberOfPlayers <= 1 ? "not-allowed" : "pointer",
                                                margin: 0,
                                              }}
                                              onClick={() => {
                                                if (item.numberOfPlayers <= 1) return;
                                                handlePackChange(
                                                  item.numberOfPlayers ? item.numberOfPlayers - 1 : 1,
                                                  index,
                                                  "numberOfPlayers"
                                                );
                                              }}
                                            >
                                              -
                                            </p>

                                          </div>
                                        </div>
                                      )}


                                    </div>
                                    </Col>

                                    <Col xs={12} md={5} lg={2}>
                                      <FormGroup
                                        className="custom-inputs select-box mb-md-0 custom-add-sale-input d-flex align-items-center"
                                        style={{ height: "52px" }}
                                      >
                                        <Input
                                          type="select"
                                          className={`form-control form-control p-0 h-100 ${errors.user &&
                                            touched.use &&
                                            "is-invalid"} d-flex align-items-center`}
                                          name={`package`}
                                          disabled={
                                            addToBookingListModal ||
                                            bookAppointmentModal
                                          }
                                          defaultValue={selectedMainMember.id}
                                          value={
                                            addToBookingListModal
                                              ? selectedMainMember.id
                                              : selectedPackages[index].member
                                          }
                                          // value={values.packageDetails[index].paymentType}

                                          onChange={(e) => {
                                            if (addToBookingListModal) return;
                                            else
                                              handlePackChange(e, index, "member");
                                          }}
                                          id="select-specific-member"
                                        >
                                          <option value={null}>{"Select"}</option>;
                                          {selectedPackages[
                                            index
                                          ].assignableMembers?.map((rel, idx) => {
                                            return (
                                              <option value={rel.id}>
                                                {rel.name}
                                              </option>
                                            );
                                          })}
                                        </Input>
                                      </FormGroup>
                                    </Col>

                                    <Col xs={12} md={6} lg={2}>
                                      <FormGroup className="custom-inputs mb-md-0 selected-package-start-date-container ">
                                        <DatePicker
                                          name="startDate"
                                          autoComplete="off"
                                          dateFormat="dd/MM/yyyy"
                                          placeholderText="DD/MM/YYYY"
                                          popperContainer={SaleDatePopperContainer}
                                          popperProps={{ positionFixed: true }}
                                          popperClassName="sale-datepicker-popper"
                                          selected={(() => {
                                            const start =
                                              selectedPackages[index]?.startDate;
                                            const date =
                                              start instanceof Date
                                                ? start
                                                : start
                                                ? new Date(start)
                                                : null;
                                            return date && !isNaN(date.getTime())
                                              ? date
                                              : null;
                                          })()}
                                          onChange={(date) => {
                                            handlePackChange(
                                              date,
                                              index,
                                              "startDate"
                                            );
                                          }}
                                        />
                                      </FormGroup>
                                    </Col>

                                    <Col xs={12} md={6} lg={2}>
                                      <FormGroup className="custom-inputs mb-md-0 selected-package-start-date-container d-flex justify-content-start align-items-center">
                                        <div
                                          style={{
                                            display: "flex",
                                            flexDirection: "column",
                                          }}
                                        >
                                          <p className="mb-1">
                                            {selectedPackages[index].startDate
                                              ? moment(
                                                  selectedPackages[index].startDate
                                                )
                                                  .add(
                                                    selectedPackages[index]
                                                      .extendDuration
                                                      ? selectedPackages[index]
                                                          .durationCount +
                                                          selectedPackages[index]
                                                            .extendDuration
                                                      : selectedPackages[index]
                                                          .durationCount,
                                                    "days"
                                                  )
                                                  .format("DD-MM-YYYY")
                                              : "N/A"}
                                          </p>

                                          <p
                                            style={{ fontSize: 13, color: "#666" }}
                                          >
                                            (
                                            {selectedPackages[index].extendDuration
                                              ? selectedPackages[index]
                                                  .durationCount +
                                                selectedPackages[index]
                                                  .extendDuration
                                              : selectedPackages[index]
                                                  .durationCount}{" "}
                                            days)
                                          </p>

                                          {(loginUser.role == "STAFF" &&
                                            !permissions["EXT-END-S"]) ||
                                          (loginUser.role == "SUB_ADMIN" &&
                                            !permissions["EXT-END-S"])
                                            ? null
                                            : gymFeaturesObject[
                                                "extendDuration"
                                              ] && (
                                                <p
                                                  style={{
                                                    fontSize: 14,
                                                    color: "#4D4467",
                                                    cursor: "pointer",
                                                    marginTop: 2,
                                                  }}
                                                  onClick={() => {
                                                    setShowExtendDuration({
                                                      [item.id]: true,
                                                    });
                                                  }}
                                                >
                                                  + Extend
                                                </p>
                                              )}
                                        </div>
                                      </FormGroup>
                                    </Col>

                                    <Col
                                      xs={12}
                                      md={6}
                                      lg={2}
                                      className="discount-field-col"
                                    >
                                      <FormGroup
                                        className="custom-inputs select-box mb-md-0 custom-add-sale-input d-flex align-items-center"
                                        style={{ height: "52px" }}
                                      >
                                        {(loginUser.role == "STAFF" &&
                                          !permissions["S-DIC-MNG"] &&
                                          !permissions["S-DIC-ADD-20"]) ||
                                        (subAdminType == "SUB_ADMIN" &&
                                          !subAdminPermissions["S-DIC-MNG"] &&
                                          !subAdminPermissions[
                                            "S-DIC-ADD-20"
                                          ]) ? null : (
                                          <>
                                            <Input
                                              type="number"
                                              className={`form-control form-control p-0 h-100 ${errors.user &&
                                                touched.use &&
                                                "is-invalid"} d-flex align-items-center`}
                                              name={`package`}
                                              placeholder="Discount"
                                              value={
                                                selectedPackages[index].discount
                                              }
                                              onChange={(e) =>
                                                discountSubscriptionOnChange(
                                                  e.target.value,
                                                  selectedPackages[index].id
                                                )
                                              }
                                              id="discount-percent-field"
                                            ></Input>
                                            <button
                                              className="btn-info"
                                              type="button"
                                              style={{ marginRight: "50px" }}
                                              onClick={() => {
                                                setDiscountSaleCalculatorOpen(true);
                                                setSelectedPackageForDiscountCalculator(
                                                  selectedPackages[index]
                                                );
                                              }}
                                            >
                                              Calc %
                                            </button>
                                          </>
                                        )}
                                      </FormGroup>
                                    </Col>

                                    <Col xs={12} md={6} lg={2}>
                                      {item.planType == "pt" || (item.planType === "GYM" && followupProgramEnabled) ? (
                                        <FormGroup
                                          className="custom-inputs select-box mb-md-0 custom-add-sale-input d-flex align-items-center"
                                          style={{ height: "52px" }}
                                        >
                                          <Input
                                            // disabled={(item.planType === "GYM" && followupProgramEnabled) && settings?.followupProgram?.automaticInstructorsRotation && settings?.followupProgram?.activeInstructors?.length}
                                            type="select"
                                            className={`form-control form-control p-0 h-100 ${errors.user &&
                                              touched.use &&
                                              "is-invalid"} d-flex align-items-center`}
                                            name={`trainer`}
                                            placeholder="Assigned Trainer"
                                            id="assigned-trainer"
                                            defaultValue={firstInstructorInRotationList?.id}
                                            onChange={(e) => {
                                              handlePackChange(
                                                e,
                                                index,
                                                "assignedTrainer"
                                              );
                                            }}
                                            // id="unussigned-field"
                                          >
                                            <option
                                              value={null}
                                              id="unussigned-field"
                                            >
                                              {"Unassigned"}
                                            </option>
                                            {item.planType == "pt" && item.trainers?.map((trainer, idx) => {
                                              return (
                                                <option value={trainer.id}>
                                                  {trainer.user.name}
                                                </option>
                                              );
                                            })}
                                            {item.planType === "GYM" && followupProgramEnabled && settings?.followupProgram?.activeInstructors?.map((trainer, idx) => {
                                              return (
                                                <option value={trainer.id}>
                                                  {trainer.name}
                                                </option>
                                              );
                                            })}
                                          </Input>
                                        </FormGroup>
                                      ) : (
                                        ""
                                      )}
                                    </Col>
                                    {
                                      (item.planType === "GYM" && followupProgramEnabled) &&
                                      <Col xs={12} md={6} lg={2}>
                                        <FormGroup
                                            className="custom-inputs select-box mb-md-0 custom-add-sale-input d-flex align-items-center"
                                            style={{ height: "52px" }}
                                          >
                                            <Input
                                              type="select"
                                              className={`form-control form-control p-0 h-100 ${errors.user &&
                                                touched.use &&
                                                "is-invalid"} d-flex align-items-center`}
                                              name={`trainer`}
                                              disabled={true} //force using first program and prevent un-assign.
                                              placeholder="Follow-up Program"
                                              id="assigned-trainer"
                                              defaultValue={followupPrograms[0]?.id}
                                              onChange={(e) => {
                                                handlePackChange(
                                                  e,
                                                  index,
                                                  "followupProgram"
                                                );
                                              }}
                                            >
                                              <option
                                                value={null}
                                                id="unussigned-fup-field"
                                              >
                                                {"Unassigned"}
                                              </option>
                                              {followupPrograms?.map((f, idx) => {
                                                return (
                                                  <option value={f.id}>
                                                    {f.name}
                                                  </option>
                                                );
                                              })}
                                            </Input>
                                        </FormGroup>
                                      </Col>
                                    }

                                    <Col
                                      xs={12}
                                      md={1}
                                      lg={1}
                                      id="delete-icon-sale"
                                    >
                                      <span
                                        onClick={() => {
                                          setToDelete(index);
                                        }}
                                        style={{
                                          color: "#E4E7Eb",
                                          cursor: "pointer",
                                        }}
                                      >
                                        {ComonIcons.delete}
                                      </span>
                                    </Col>

                                    {showExtendDuration &&
                                      showExtendDuration[item?.id] && (
                                        <Modal
                                          isOpen={showExtendDuration[item?.id]}
                                          toggle={() =>
                                            setShowExtendDuration({
                                              [item?.id]: false,
                                            })
                                          }
                                          centered={true}
                                          size="m"
                                        >
                                          <ModalBody>
                                            <div className="bg-white mx-2">
                                              <div className="d-flex align-items-center border-bottom-1 pb-4">
                                                <div className="d-inline-flex ">
                                                  <Title
                                                    title="Add Duration  "
                                                    subtitlestyle="ctf-tx-secondary"
                                                  />
                                                </div>
                                                <div className="d-inline-flex ml-auto">
                                                  <div className="close-icons pb-0">
                                                    <div className="text-right">
                                                      <span
                                                        className="svg-block"
                                                        onClick={() =>
                                                          setShowExtendDuration({
                                                            [item?.id]: false,
                                                          })
                                                        }
                                                      >
                                                        {ComonIcons.closeBlack}
                                                      </span>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                              <Row className="mb-4 mt-2">
                                                <Col sm={12} lg={4}>
                                                  <Label
                                                    forhtml="exampleText"
                                                    className="pl-2"
                                                  >
                                                    Add Duration in days
                                                  </Label>
                                                  <Input
                                                    type="number"
                                                    name="text"
                                                    id="note"
                                                    max={20}
                                                    onChange={(e) => {
                                                      // setNote(e.target.value);
                                                      handlePackChange(
                                                        e,
                                                        index,
                                                        "extendDuration"
                                                      );
                                                    }}
                                                  />
                                                </Col>
                                                <Col
                                                  sm={12}
                                                  lg={12}
                                                  className="mt-2"
                                                >
                                                  <Label
                                                    forhtml="exampleText"
                                                    className="pl-2"
                                                  >
                                                    Add Reason
                                                  </Label>
                                                  <Input
                                                    type="textarea"
                                                    minLength="250px"
                                                    name="reason"
                                                    id="reason"
                                                    onChange={(e) => {
                                                      if (!e.target.value) {
                                                        toastr.error(
                                                          "Please add a reason"
                                                        );
                                                        return;
                                                      }
                                                      if (
                                                        e.target.value.length < 10
                                                      ) {
                                                        toastr.error(
                                                          "Min character is 10"
                                                        );
                                                        return;
                                                      }
                                                      handlePackChange(
                                                        e,
                                                        index,
                                                        "reason"
                                                      );
                                                    }}
                                                  />
                                                </Col>
                                              </Row>
                                            </div>
                                            {/* <Row className="align-items-center">
                                            */}
                                            {/* <Col md={12} className="px-0"> */}
                                            <div className="align-items-center">
                                              <button
                                                className="btn btn-medium min-width-100 ml-4"
                                                type="button"
                                                onClick={() => {
                                                  // here will add to package the extend duration and update the end date with selected duration

                                                  if (
                                                    !selectedPackages[index]
                                                      ?.extendDuration
                                                  ) {
                                                    toastr.error(
                                                      "Please select duration"
                                                    );
                                                    return;
                                                  }
                                                  if (
                                                    !selectedPackages[index]?.reason
                                                  ) {
                                                    toastr.error(
                                                      "Please Add reason"
                                                    );
                                                    handlePackChange(
                                                      { target: 0 },
                                                      index,
                                                      "extendDuration"
                                                    );
                                                    return;
                                                  }
                                                  setShowExtendDuration({
                                                    [item?.id]: false,
                                                  });
                                                }}
                                              >
                                                Extend end Date{" "}
                                              </button>{" "}
                                            </div>

                                            {/* <div className="action-wrapper blk-padding-y d-flex justify-content-between minimize-btns">
                                                  <div className="action-inner-block d-flex justify-content-between ml-10">
                                                    
                                                  </div>
                                                </div> */}
                                            {/* </Col>
                                            </Row> */}
                                          </ModalBody>
                                        </Modal>
                                      )}
                                    {discountSaleCalculatorOpen &&
                                      selectedPackageForDiscountCalculator && (
                                        <DiscountSaleCalculator
                                          originalAmount={
                                            selectedPackageForDiscountCalculator.price
                                          }
                                          discount={
                                            selectedPackageForDiscountCalculator.discount
                                          }
                                          discountSaleCalculatorOpen={
                                            discountSaleCalculatorOpen
                                          }
                                          setDiscountSaleCalculatorOpen={
                                            setDiscountSaleCalculatorOpen
                                          }
                                          setDiscount={(v) =>
                                            discountSubscriptionOnChange(
                                              v,
                                              selectedPackageForDiscountCalculator.id
                                            )
                                          }
                                        />
                                      )}
                                  </Row>
                                );
                              })}
                          </Row>
                           </>
                      )}
                    </Row>
                  }
                </Row>
              </Row>
            </Row>
          </div>
        </div>

        {// conditions (values.requiredAttachment && !data.rows.lenght)
        values.requiredAttachment &&
          memberHasIdDocument === false &&
          !showVoiceIdentityUpload && (
        <div className="d-flex justify-content-center mb-3">
             <Row
           style={{
            backgroundColor: "#f5f7f8",
            marginRight: "0",
            marginLeft: "0",
          }}
            >
              <UploadOrCapture
                label="Upload Member's Identity"
                folder="memberDocs"
                setSelectedFile={setSelectedFile}
                onFileSelect={(url) => {
                  console.log("Selected:", url);
                 setContent(url);
                 setFieldValue("attachment",url);
                }}
              />

          </Row>
        </div>
         )}
         { selectedPackages && selectedPackages.length > 0 && settings?.membershipSettings?.changedAssignedSale && (
            <Row
                style={{
                  backgroundColor: "#f5f7f8",
                  marginRight: "0",
                  marginLeft: "0",
                }}
              >
                <Col md={4} className="pt-3 pb-3">
                  <FormGroup className="custom-inputs with-icon mb-md-0">
                      <Input
                      type="select"
                      className={`form-contro`}
                      name={`package`}
                      onChange={(e) => {
                        setFieldValue(
                          "assignedSaleTo",
                          e.target.value
                        );
                      }}
                    >
                      <option value={null}>{"Select"}</option>
                      {settings?.membershipSettings?.activeUsers.length ? (
                       settings.membershipSettings.activeUsers.map((user) => {  
                        return (
                          <option value={user.id}>
                            {user.name}
                          </option>
                        );
                       }
                      )):users?.map((el) => {
                        return (
                          <option value={el.value}>
                            {el.label}
                          </option>
                        );
                      })}
                      
                    </Input>
                    <Label
                      for="price"
                      className="grey-background"
                      style={{
                        background: "#F5F7F8",
                        mixBlendMode: "normal",
                      }}
                    >
                      Assigned sale to other user
                    </Label>
                    <small style={{ color: "#666" }}>by default sale assigned to the logged-in user</small>
                  </FormGroup>
                </Col>
            </Row>   
            )
         }
        <Row
          style={{
            backgroundColor: "#f5f7f8",
            marginRight: "0",
            marginLeft: "0",
          }}
        >
          {(loginUser.role == "STAFF" && !permissions["S-TAX-CH"]) ||
          (loginUser.role == "SUB_ADMIN" && !permissions["S-TAX-CH"]) ? null : (
            <Col md={4} className="pt-3 pb-3">
              <FormGroup className="custom-inputs with-icon mb-md-0">
                <Field
                  type="number"
                  name="tax"
                  id="id"
                  value={formikProps.values.tax ? formikProps.values.tax : 0}
                  placeholder="Tax.."
                  className={`form-control ${errors.tax &&
                    touched.tax &&
                    "is-invalid"}`}
                  style={{ color: "black", background: "#F5F7F8 " }}
                  onChange={(e) => {
                    setFieldValue("tax", parseInt(e.target.value));
                    setSinglePackageTouched(!singlePackageTouched);
                  }}
                />
                {errors.tax && touched.tax ? (
                  <div className="invalid-feedback">{`${errors.tax}`}</div>
                ) : null}
                <Label
                  for="price"
                  className="grey-background"
                  style={{
                    background: "#F5F7F8",
                    mixBlendMode: "normal",
                  }}
                >
                  Tax (%)
                </Label>
              </FormGroup>
            </Col>
          )}
        </Row>
        <div className="d-flex justify-content-center">
          <Row xs={12} className="sale-summary">
            <Col xs={12} md={6} lg={3} className="summary-item-sigle-container">
              <span className="item-text">Item no:</span>
              <span>
                {selectedPackages.length} Subscriptions {"/"}{" "}
                {selectedProducts.length} Products
              </span>
            </Col>
            <Col xs={12} md={6} lg={3} className="summary-item-sigle-container">
              <span className="item-text">Price:</span>
              <span>
                {totalPrice?.toLocaleString() || 0}{" "}
                {/* {parseFloat(totalPrice).toFixed(2).toLocaleString() || "0"}{" "} */}
                {
                  JSON.parse(localStorage.getItem("connectToFitGymPanelUser"))
                    .currency
                }
              </span>
            </Col>
            <Col xs={12} md={6} lg={3} className="summary-item-sigle-container">
              <span className="item-text">Discount:</span>
              <span>
                {totalDiscount?.toLocaleString()}{" "}
                {
                  JSON.parse(localStorage.getItem("connectToFitGymPanelUser"))
                    .currency
                }
              </span>
            </Col>
            <Col xs={12} md={6} lg={3} className="summary-item-sigle-container">
              <span className="item-text">Total Price (inc. tax):</span>
              <span>
                {priceWithTax
                  ? parseFloat(priceWithTax)?.toLocaleString()
                  : 0.0}{" "}
                {/* {parseFloat(priceWithTax?.toLocaleString() || 0.0).toFixed(2)  || "0"}{" "} */}
                {
                  JSON.parse(localStorage.getItem("connectToFitGymPanelUser"))
                    .currency
                }
              </span>
            </Col>
          </Row>
        </div>
        {gymFeaturesObject["joiningFees"] &&
        !memberPaidJoiningFees &&
        values.paymentType !== "CO" &&
        selectedPackages?.length ? (
          <div className="d-flex justify-content-center">
            <Row xs={12} className="sale-summary justify-content-center">
              <Col
                xs={12}
                md={6}
                lg={4}
                className="summary-item-sigle-container"
              >
                <span className="item-text">Added Joining Fees :</span>

                <span>
                  {values?.joiningFees} {""}
                  {
                    JSON.parse(localStorage.getItem("connectToFitGymPanelUser"))
                      .currency
                  }
                </span>
              </Col>
              <Col
                xs={12}
                md={6}
                lg={4}
                className="summary-item-sigle-container"
              >
                <span className="item-text">
                  Total Price (inc. Joining Fees):
                </span>

                <span>
                  {priceWithTax
                    ? (
                        parseFloat(priceWithTax) + values?.joiningFees
                      )?.toLocaleString()
                    : 0.0}{" "}
                  {
                    JSON.parse(localStorage.getItem("connectToFitGymPanelUser"))
                      .currency
                  }
                </span>
              </Col>
            </Row>
          </div>
        ) : null}
        
        {
          
          hasInsuranceEligiblePackage&&insuranceDetails && insuranceDetails?.Copayment && selectedPackages?.length ? (
            <div className="d-flex justify-content-center">
              <Row xs={12} className="sale-summary justify-content-center">
                 <Col
                  xs={12}
                  md={6}
                  lg={6}
                  className="summary-item-sigle-container"
                >
                  <span className="item-text">Copayment:</span>
                  <span>
                    {`${insuranceDetails?.Copayment || 0}% of ${selectedPackages
                    ?.filter(p => p.supportInsurance)
                    ?.map(p => p.name)
                    ?.join(", ")}`}
                  </span>
                </Col>
                 <Col
                  xs={12}
                  md={6}
                  lg={3}
                  className="summary-item-sigle-container"
                >
                  <span className="item-text">Insurance Company:</span>
                  <span>
                    {insuranceDetails?.insuranceCompany || 0}
                  </span>
                </Col>
          
                <Col
                  xs={12}
                  md={6}
                  lg={3}
                  className="summary-item-sigle-container"
                >
                  <span className="item-text">Total After Insurance:</span>
                  <span>
                    {totalAmountAfterInsuranceCoverage?.toLocaleString() || 0.0}{" "}
                    {
                      JSON.parse(localStorage.getItem("connectToFitGymPanelUser"))
                        .currency
                    }
                  </span>
                </Col>
                
              </Row>
            </div>
          ) : null  
        }
        <div className="trainer-gender-default-wrapper border-bottom-1 blk-padding-y">
          <div className="info-title pb-0">
            <Title title={"Payment Info"} />
          </div>
          <div className="status-inner-block">
            <div className="status-inner-block">
              <div className="subscription-plan-list-element">
                <div className="">
                  <div
                    className="form-check form-check-inline custom-btn-radio"
                    onChange=""
                  >
                    <Field
                      type="radio"
                      name="paymentType"
                      id="cash"
                      value="L"
                      className="form-check-input"
                    />

                    <label className="form-check-label label-blk" for="cash">
                      Cash
                    </label>
                  </div>
                </div>
              </div>
              <div className="subscription-plan-list-element">
                <div className="">
                  <div
                    className="form-check form-check-inline custom-btn-radio"
                    checked
                    onChange=""
                  >
                    <Field
                      type="radio"
                      name="paymentType"
                      id="check"
                      value="CQ"
                      className="form-check-input"
                    />
                    <label className="form-check-label label-blk" for="check">
                      Check
                    </label>
                  </div>
                </div>
              </div>
              <div className="subscription-plan-list-element">
                <div className="">
                  <div
                    className="form-check form-check-inline custom-btn-radio"
                    onChange=""
                  >
                    <Field
                      type="radio"
                      name="paymentType"
                      id="visa"
                      value="CC"
                      className="form-check-input"
                    />

                    <label className="form-check-label label-blk" for="visa">
                      Visa/MC
                    </label>
                  </div>
                </div>
              </div>

              {(loginUser.role == "STAFF" && !permissions["COM-ADD"]) ||
              (loginUser.role == "SUB_ADMIN" &&
                !permissions["COM-ADD"]) ? null : (
                <div className="subscription-plan-list-element">
                  <div className="">
                    <div
                      className="form-check form-check-inline custom-btn-radio"
                      checked
                      onChange=""
                    >
                      <Field
                        type="radio"
                        name="paymentType"
                        id="complimentary"
                        value="CO"
                        className="form-check-input"
                      />
                      <label
                        className="form-check-label label-blk complementary-radio-add-sale"
                        for="complimentary"
                      >
                        Complimentary
                      </label>
                    </div>
                  </div>
                </div>
              )}

              {showComReason && gymFeaturesObject["addReasonForComplimantry"] && (
                <Modal
                  isOpen={showComReason}
                  toggle={() => setShowComReason(false)}
                  centered={true}
                  size="m"
                >
                  <ModalBody>
                    <div className="bg-white mx-2">
                      <div className="d-flex align-items-center border-bottom-1 pb-4">
                        <div className="d-inline-flex ">
                          <Title
                            title="Add Reason  "
                            subtitlestyle="ctf-tx-secondary"
                          />
                        </div>
                        <div className="d-inline-flex ml-auto">
                          <div className="close-icons pb-0">
                            <div className="text-right">
                              <span
                                className="svg-block"
                                onClick={() => setShowComReason(false)}
                              >
                                {ComonIcons.closeBlack}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <Row className="mb-4 mt-2">
                        <Col sm={12} lg={12} className="mt-2">
                          <Label forhtml="exampleText" className="pl-2">
                            Add Reason
                          </Label>
                          <Input
                            type="textarea"
                            name="reason"
                            id="reason"
                            style={{ minHeight: "250px" }}
                            onChange={(e) => {
                              if (!e.target.value) {
                                toastr.error("Please add a reason");
                                return;
                              }
                              if (e.target.value.length < 10) {
                                toastr.error("Min character is 10");
                                return;
                              }
                              setFieldValue(
                                "complimantryReason",
                                e.target.value
                              );
                            }}
                          />
                        </Col>
                      </Row>
                    </div>
                    {/* <Col md={12} className="px-0"> */}
                    <div className="align-items-center">
                      <button
                        className="btn btn-medium min-width-100 ml-4"
                        type="button"
                        onClick={() => setShowComReason(false)}
                      >
                        Add Note
                      </button>{" "}
                    </div>
                  </ModalBody>
                </Modal>
              )}
              <div className="subscription-plan-list-element">
                <div className="">
                  <div
                    className="form-check form-check-inline custom-btn-radio"
                    checked
                    onChange=""
                  >
                    <Field
                      type="radio"
                      name="paymentType"
                      id="bank"
                      value="BA"
                      className="form-check-input"
                    />
                    <label
                      className="form-check-label label-blk complementary-radio-add-sale"
                      for="bank"
                    >
                      Bank
                    </label>
                  </div>
                </div>
              </div>

              <div
                className="subscription-plan-list-element"
                style={{
                  display:
                    (selectedPackages.length + selectedProducts.length === 1)
                      ? "inline-block"              // hide if mix of both
                      : "none",      // show if only one type selected
                }}
              >
                <div className="">
                  <div
                    className="form-check form-check-inline custom-btn-radio"
                    checked
                  >
                    <Field
                      type="radio"
                      name="paymentType"
                      id="split"
                      value="SP"
                      className="form-check-input"
                    />
                    <label
                      className="form-check-label label-blk complementary-radio-add-sale"
                      for="split"
                    >
                      Split
                    </label>
                  </div>
                </div>
              </div>
            </div>
            {errors.paymentStatus && touched.paymentStatus ? (
              <div
                className="invalid-feedback"
                style={{ display: "block" }}
              >{`${errors.paymentStatus}`}</div>
            ) : null}
          </div>
        </div>
        {values.paymentType == "SP" && (
          <div
            className={`trainer-gender-default-wrapper ${
              values.paymentType !== "P" ? "border-bottom-1" : ""
            } blk-padding-y`}
          >
            <div className="info-title pb-0">
              <Title title={"Split Payment info"} />
            </div>
            <div className="status-inner-block">
              <Row className="mt-4">
                <Col md={6}>
                  <FormGroup className="custom-inputs mb-md-0">
                    <ReactSelect
                      id="payment"
                      isClearable
                      name="payment"
                      onChange={async (value) => {
                        /**
                         * first will delete the selected choise from options
                         * will set the split first object.type
                         */
                        let arr = [...paymentOptions];
                        setPaymentOption2(
                          arr.filter((op) => {
                            return op.value !== value.value;
                          })
                        );
                        let split = {
                          type: value.value,
                          amount: values.split.length
                            ? values.split[0]?.amount
                            : 0,
                        };
                        let arrOfSplit = [...values.split];
                        arrOfSplit[0] = split;
                        setFieldValue("split", arrOfSplit);
                      }}
                      options={paymentOptions}
                      className={`form-control multi-select-search-block p-0 ${errors.split &&
                        touched.split &&
                        "is-invalid"}`}
                      disabled={selectedPackages.length + selectedProducts.length !== 1}
                    />
                    <Label
                      className="grey-background"
                      style={{
                        background: "white",
                        mixBlendMode: "normal",
                      }}
                    >
                      {"Payment Type"}
                    </Label>
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup className="custom-inputs mb-md-0">
                    <Field
                      disabled={selectedPackages.length + selectedProducts.length !== 1}
                      type="number"
                      step="0.01"
                      name={"amount"}
                      placeholder={"Start Typing"}
                      onChange={(e) => {
                        let split = {
                          type: values.split.length
                            ? values.split[0]?.type
                            : "",
                          amount: e.target.value,
                        };
                        let arr = [...values.split];
                        arr[0] = split;
                        setFieldValue("split", arr);
                      }}
                      id="amount"
                      className="form-control col-xs-6"
                    />
                    <Label
                      className="grey-background"
                      style={{
                        background: "white",
                        mixBlendMode: "normal",
                      }}
                    >
                      {"amount"}
                    </Label>
                  </FormGroup>
                </Col>
              </Row>
              <Row className="mt-4">
                <Col md={6}>
                  <FormGroup className="custom-inputs mb-md-0">
                    <ReactSelect
                      id="payment"
                      isClearable
                      name="payment"
                      onChange={(value) => {
                        let split = {
                          type: value.value,
                          amount:
                            values.split.length && values.split[1]
                              ? values?.split[1]?.amount
                              : 0,
                        };
                        let arrOfSplit = [...values.split];
                        arrOfSplit[1] = split;
                        setFieldValue("split", arrOfSplit);
                      }}
                      options={paymentOption2}
                      className={`form-control multi-select-search-block p-0 ${errors.split &&
                        touched.split &&
                        "is-invalid"}`}
                      disabled={selectedPackages.length + selectedProducts.length !== 1}
                    />
                    <Label
                      className="grey-background"
                      style={{
                        background: "white",
                        mixBlendMode: "normal",
                      }}
                    >
                      {"Payment Type"}
                    </Label>
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup className="custom-inputs mb-md-0">
                    <Field
                      disabled={selectedPackages.length + selectedProducts.length !== 1}
                      type="number"
                      step="0.01"
                      name={"amount"}
                      placeholder={"Start Typing"}
                      onChange={(e) => {
                        let split = {
                          type: values.split.length ? values.split[1].type : "",
                          amount: e.target.value,
                        };

                        let arrOfSplit = [...values.split];
                        arrOfSplit[1] = split;
                        setFieldValue("split", arrOfSplit);
                      }}
                      id="receivedAmount"
                      className="form-control col-xs-6"
                    />
                    <Label
                      className="grey-background"
                      style={{
                        background: "white",
                        mixBlendMode: "normal",
                      }}
                    >
                      {"amount"}
                    </Label>
                  </FormGroup>
                </Col>
              </Row>
            </div>
          </div>
        )}
        {memberCreditApplicable && values.paymentType !== "CO" && (
          <div className="trainer-gender-default-wrapper border-bottom-1 blk-padding-y">
            <div className="info-title pb-0">
              <Title title={"Member Credit"} />
            </div>
            <Row className="mt-4">
              <Col md={4}>
                <FormGroup className="custom-inputs mb-md-0">
                  <Input
                    disabled
                    value={
                      memberCreditLoading
                        ? "Loading..."
                        : memberCreditBalance.toFixed(2)
                    }
                  />
                  <Label className="grey-background">Available Credit</Label>
                </FormGroup>
              </Col>
              <Col md={4}>
                <FormGroup className="custom-inputs mb-md-0">
                  <Field
                    type="number"
                    min="0"
                    max={Math.min(memberCreditBalance, memberCreditPackageDue)}
                    step="0.01"
                    name="creditToUse"
                    className="form-control"
                    disabled={memberCreditLoading || memberCreditBalance <= 0}
                    onChange={(event) => {
                      const requested = Number(event.target.value) || 0;
                      if (requested > memberCreditBalance) {
                        setMemberCreditError(
                          "Credit used cannot exceed available credit."
                        );
                      } else if (requested > memberCreditPackageDue) {
                        setMemberCreditError(
                          "Credit used cannot exceed the package amount due."
                        );
                      } else {
                        setMemberCreditError("");
                      }
                      setFieldValue("creditToUse", event.target.value);
                    }}
                  />
                  <Label className="grey-background">Use Member Credit</Label>
                </FormGroup>
              </Col>
              {values.paymentType !== "SP" && (
                <Col md={4}>
                  <FormGroup className="custom-inputs mb-md-0">
                    <Field
                      type="text"
                      inputMode="decimal"
                      autoComplete="off"
                      name="physicalPayment"
                      className="form-control"
                      onChange={(event) => {
                        const raw = event.target.value;
                        if (raw !== "" && !/^\d*\.?\d{0,2}$/.test(raw)) return;
                        setMemberCreditError("");
                        setFieldValue("physicalPayment", raw);
                      }}
                    />
                    <Label className="grey-background">Amount Paid Now</Label>
                  </FormGroup>
                </Col>
              )}
            </Row>
            {memberCreditError && (
              <div className="invalid-feedback d-block">{memberCreditError}</div>
            )}
            <Row className="mt-4">
              <Col md={4}>Package Price: {memberCreditCalculation.packageDue.toFixed(2)}</Col>
              <Col md={4}>Applied To Package: {memberCreditCalculation.receivedForSubscription.toFixed(2)}</Col>
              <Col md={4}>Advance Credit: {memberCreditCalculation.advanceCredit.toFixed(2)}</Col>
              <Col md={4} className="mt-2">Remaining: {memberCreditCalculation.remainingAmount.toFixed(2)}</Col>
              <Col md={4} className="mt-2">Credit After Sale: {memberCreditCalculation.resultingCredit.toFixed(2)}</Col>
            </Row>
          </div>
        )}
        {!memberCreditApplicable && values.paymentType !== "CO" && (
          <div
            className={`trainer-gender-default-wrapper ${
              values.paymentType !== "P" ? "border-bottom-1" : ""
            } blk-padding-y`}
          >
            <div className="info-title pb-0">
              <Title title={"Payment Type"} />
            </div>
            <div className="status-inner-block">
              <div className="status-inner-block">
                <div className="subscription-plan-list-element">
                  <div className="">
                    <div
                      className="form-check form-check-inline custom-btn-radio"
                      onChange=""
                    >
                      <Field
                        type="radio"
                        name="paymentStatus"
                        id="gymRadio"
                        value="F"
                        className="form-check-input"
                        disabled={values.paymentType == "CO"}
                        //   onClick={e => setFieldValue("trainer", "")}
                      />

                      <label
                        className="form-check-label label-blk"
                        for="gymRadio"
                      >
                        Full Payment
                      </label>
                    </div>
                  </div>
                </div>

                {(loginUser.role == "STAFF" && !permissions["S-SAL-PAPAY"]) ||
                (loginUser.role == "SUB_ADMIN" && !permissions["S-SAL-PAPAY"])
                  ? null
                  : partialPaymentApplicable && (
                      <div className="subscription-plan-list-element">
                        <div className="">
                          <div
                            className="form-check form-check-inline custom-btn-radio"
                            checked
                            onChange=""
                          >
                            <Field
                              type="radio"
                              name="paymentStatus"
                              id="ptRadio"
                              value="P"
                              className="form-check-input"
                              onClick={(e) =>
                                setFieldValue("paymentStatus", e.target.value)
                              }
                              disabled={values.paymentType == "CO"}
                            />
                            <label
                              className="form-check-label label-blk"
                              for="ptRadio"
                            >
                              Partial Payment
                            </label>
                          </div>
                        </div>
                      </div>
                    )}
              </div>
              {errors.paymentStatus && touched.paymentStatus ? (
                <div
                  className="invalid-feedback"
                  style={{ display: "block" }}
                >{`${errors.paymentStatus}`}</div>
              ) : null}
            </div>
            {partialPaymentApplicable && values.paymentStatus === "P" && (
              <Row className="members-date-edit-wrapper blk-padding-y pt-0 mt-4">
                <Col md={4}>
                  <FormGroup className="custom-inputs mb-md-0">
                    <Field
                      disabled={selectedPackages.length === 0}
                      type="number"
                      name={"receivedAmount"}
                      placeholder={"Start Typing"}
                      max={totalRecieved ? totalRecieved : totalAmountAfterInsuranceCoverage?
                        totalAmountAfterInsuranceCoverage: priceWithTax}
                      value={
                        totalRecieved
                          ? totalRecieved
                          : values.receivedAmount !== "0"
                          ? values.receivedAmount
                          : null
                      }
                      onChange={(e) => handlePaidAmount(e)}
                      id="receivedAmount"
                      className="form-control col-xs-6"
                      min={0}
                      step="0.01"
                    />
                    <Label
                      className="grey-background"
                      style={{
                        background: "white",
                        mixBlendMode: "normal",
                      }}
                    >
                      {"Received Amount"}
                    </Label>
                  </FormGroup>
                </Col>
                {/** show how much paid as joining fees and if recievedAmount and member has not paid joining fees */}
                {!memberPaidJoiningFees && values?.receivedAmount !== "0" && (
                  <>
                    <Col md={4}>
                      <FormGroup className="custom-inputs mb-md-0">
                        <Field
                          disabled={true}
                          type="number"
                          name={"joiningFees"}
                          value={values?.joiningFees}
                          id="joiningFees"
                          className="form-control col-xs-6"
                        />
                        <Label
                          className="grey-background"
                          style={{
                            background: "white",
                            mixBlendMode: "normal",
                          }}
                        >
                          {"Joining Amount"}
                        </Label>
                      </FormGroup>
                    </Col>
                    <Col md={4}>
                      <FormGroup className="custom-inputs mb-md-0">
                        <Field
                          disabled={true}
                          type="number"
                          name={"subscriptionAmount"}
                          value={
                            values.receivedAmount !== "0"
                              ? values.receivedAmount
                              : null
                          }
                          id="subscriptionAmount"
                          className="form-control col-xs-6"
                        />
                        <Label
                          className="grey-background"
                          style={{
                            background: "white",
                            mixBlendMode: "normal",
                          }}
                        >
                          {"Amount for subscription"}
                        </Label>
                      </FormGroup>
                    </Col>
                  </>
                )}

                <Col
                  md={4}
                  className={`${!memberPaidJoiningFees &&
                    (values?.receivedAmount !== 0 ||
                      values?.receivedAmount !== "0") &&
                    !totalRecieved &&
                    "mt-3"}`}
                >
                  <FormGroup className="custom-inputs mb-md-0">
                    <Field
                      type="number"
                      disabled
                      name={"remainingAmount"}
                      placeholder={"Remaining Amount"}
                      id="remainingAmount"
                      className="form-control col-xs-6"
                    />
                  </FormGroup>
                </Col>
                {errors.receivedAmount && touched.receivedAmount ? (
                  <div
                    className="invalid-feedback"
                    style={{ display: "block" }}
                  >{`${errors.receivedAmount}`}</div>
                ) : null}
              </Row>
            )}
          </div>
        )}
        {selectedPackages.length > 0 && (
          <div className="trainer-gender-default-wrapper blk-padding-y">
            <div className="info-title pb-0">
              <Title title="Note" />
            </div>
            <Row className="mt-3">
              <Col md={12}>
                <FormGroup className="custom-inputs mb-md-0">
                  <Input
                    type="textarea"
                    name="saleNote"
                    id="saleNote"
                    value={values.saleNote || ""}
                    placeholder="Add an optional note"
                    style={{ minHeight: "120px" }}
                    onChange={(e) => setFieldValue("saleNote", e.target.value)}
                  />
                </FormGroup>
              </Col>
            </Row>
          </div>
        )}
      </div>

      {isMemberInfoModalOpen && (
        <MemberInfoModal
          isMemberInfoModalOpen={isMemberInfoModalOpen}
          setIsMemberInfoModalOpen={setIsMemberInfoModalOpen}
          member={member}
        />
      )}
      {isImportDataLoading && <ImportDataPopup />}
    </>
  );
};
